(function(){
  "use strict";
  if(window.__SPARC_DRIVER_V1_14_LOADED__)return;
  window.__SPARC_DRIVER_V1_14_LOADED__ = !0;
  var SERIES_SCOPE = "driver", IDS = {
    finish: "sparc-driver-finish", grip: "sparc-driver-grip", leatherWrap: "sparc-shared-leather-wrap", leatherColor: "sparc-driver-leather-color", leatherTemplate: "sparc-driver-leather-template", stitching: "sparc-shared-stitching", adapter: "sparc-driver-adapter", hubSleeve: "sparc-muscle-hub-sleeve", careKit: "sparc-shared-care-kit"
  }, CORE_REF_KEYS = ["finish", "grip", "leatherWrap", "adapter"], STITCH_COLORS = {
    Black: "#151515", Red: "#b62323", White: "#efefef", Silver: "#a4a4a4", Gray: "#6f6f6f", Gold: "#c7a32b", Tan: "#b99a74", Brown: "#765038", "Dark Brown": "#402b22", "Dark Blue": "#263e6d", "Lime Green": "#82c341", Purple: "#673a78"
  }, FRIENDLY = {
    "None (raw finish)": "No Leather"
  }, refs = {
  }, panel = null, sourceHost = null, accs = {
  }, tabs = {
  }, mirrors = {
  }, syncPending = !1, syncTimer = null, resizeFrame = 0, resizeTrackUntil = 0;
  function q(sel, root){
    return(root || document).querySelector(sel)
  }
  function qa(sel, root){
    return Array.prototype.slice.call((root || document).querySelectorAll(sel))
  }
  function clean(s){
    return String(s || "").replace(/\s+/g, " ").trim()
  }
  function friendly(v){
    if(!v)return"Not selected";
    var display = FRIENDLY[v] || v;
    return display = String(display).replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ").replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ").replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ").replace(/\s+/g, " ").trim(), display
  }
  function normalizeAccessoryValue(value){
    return friendly(value).replace(/[\u201C\u201D\u2033]/g, '"').replace(/[\u2018\u2019\u2032]/g, "'").toLowerCase().trim()
  }
  function valueEquals(value, expected){
    var left = normalizeAccessoryValue(value), right = normalizeAccessoryValue(expected);
    return left === right
  }
  function spacerIsSelected(value){
    var v = normalizeAccessoryValue(value);
    return v === '1"' || v === '1.5"'
  }
  function el(tag, cls, text){
    var n = document.createElement(tag);
    return cls && (n.className = cls), text != null && (n.textContent = text), n
  }
  function refreshRefs(){
    Object.keys(IDS).forEach(function(k){
      var live = k === "careKit"?resolveAccessoryRef(k): document.getElementById(IDS[k]);
      if(live){
        refs[k] = live;
        return
      }
      if(k === "leatherColor" || k === "leatherTemplate" || k === "stitching" || k === "hubSleeve" || k === "careKit"){
        refs[k] = null;
        return
      }
      refs[k] = refs[k] || null
    })
  }
  function allRefsPresent(){
    var missing = [];
    return refreshRefs(), CORE_REF_KEYS.forEach(function(k){
      refs[k] || missing.push(IDS[k])
    }), missing
  }
  function commonAncestor(nodes){
    if(nodes = (nodes || []).filter(Boolean), !nodes.length)return null;
    for(var p = nodes[0]; p && p !== document.body; ){
      if(nodes.every(function(n){
        return p.contains(n)
      }))return p;
      p = p.parentElement
    }
    return null
  }
  function containsCoreRef(node){
    return node?CORE_REF_KEYS.some(function(k){
      var core = refs[k] || document.getElementById(IDS[k]);
      return!!(core && core !== node && node.contains(core))
    }): !1
  }
  function compactFieldRootForSelect(sel, labelText){
    if(!sel)return null;
    for(var wanted = clean(labelText).toLowerCase(), best = sel.parentElement || sel, p = best, i = 0; i < 4 && p && p !== document.body; i++, p = p.parentElement){
      var selectCount = qa("select", p).length, text = clean(p.textContent).toLowerCase();
      if(selectCount === 1 && text.indexOf(wanted) !== - 1){
        best = p;
        break
      }
    }
    return best
  }
  function selectOptionText(sel){
    return sel?qa("option", sel).map(function(opt){
      return clean(opt.textContent).toLowerCase()
    }).join(" | "): ""
  }
  function findSelectBySignature(testFn){
    var scope = document.getElementById("ProductSection") || document.querySelector("form[action*='/cart/add']") || document;
    return qa("select", scope).find(function(sel){
      return!!testFn(sel, selectOptionText(sel))
    }) || null
  }
  function findSpacerFinishRoot(){
    var direct = document.getElementById(IDS.columnSpacerFinish);
    if(direct){
      var directSelect = sourceSelect(direct);
      if(directSelect)return directSelect;
      if(direct.tagName === "SELECT")return direct
    }
    var sel = findSelectBySignature(function(node, text){
      var descriptor = clean((node.name || "") + " " + (node.id || "") + " " + (node.getAttribute("data-name") || "") + " " + (node.getAttribute("aria-label") || "")).toLowerCase();
      return/column.*spacer.*finish/.test(descriptor) || text.indexOf("choose column spacer finish") !== - 1 || text.indexOf("choose driver series column spacer finish") !== - 1?!0: text.indexOf("machine finish") !== - 1 && text.indexOf("satin black") !== - 1 && text.indexOf("polished") !== - 1
    });
    return sel?(sel.id || (sel.id = IDS.columnSpacerFinish), sel): null
  }
  function findCareKitRoot(){
    var direct = document.getElementById(IDS.careKit);
    if(direct){
      var directSelect = sourceSelect(direct);
      if(directSelect)return directSelect;
      if(direct.tagName === "SELECT")return direct
    }
    var sel = findSelectBySignature(function(node, text){
      var descriptor = clean((node.name || "") + " " + (node.id || "") + " " + (node.getAttribute("data-name") || "") + " " + (node.getAttribute("aria-label") || "")).toLowerCase();
      return/steering.*wheel.*care.*kit/.test(descriptor) || text.indexOf("choose steering wheel care kit") !== - 1
    });
    return sel?(sel.id || (sel.id = IDS.careKit), sel): null
  }
  function resolveAccessoryRef(key){
    return key === "careKit"?findCareKitRoot(): document.getElementById(IDS[key])
  }
  function sourceSelect(root){
    return root?root.tagName === "SELECT"?root: q("select", root): null
  }
  function sourceInputs(root){
    return root?root.matches && root.matches('input[type="radio"],input[type="checkbox"]')?[root]: qa('input[type="radio"],input[type="checkbox"]', root): []
  }
  function sourceVisible(root){
    if(!root)return!1;
    for(var p = root, i = 0; i < 8 && p && p !== document.body; i++, p = p.parentElement){
      var s = getComputedStyle(p);
      if(s.display === "none" || s.visibility === "hidden" || p.hidden === !0 || p.getAttribute("aria-hidden") === "true")return!1
    }
    return!0
  }
  function labelForInput(input, root){
    if(input && input.id)try{
      var lab = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if(lab)return lab
    }
    catch(e){
    }
    return input?input.closest("label") || q("label", root): null
  }
  function choiceContainer(input, root){
    for(var p = input, i = 0; i < 5 && p && p !== root; i++, p = p.parentElement)if(q("img", p))return p;
    return labelForInput(input, root) || input && input.parentElement
  }
  function cssUrl(value){
    if(!value || value === "none")return"";
    var m = String(value).match(/url\((['"]?)(.*?)\1\)/i);
    return m?m[2]: ""
  }
  function pseudoMediaUrl(node, pseudo){
    if(!node)return"";
    try{
      var style = getComputedStyle(node, pseudo), bg = style && style.backgroundImage;
      return cssUrl(bg)
    }
    catch(e){
      return""
    }
  }
  function mediaUrl(node){
    if(!node)return"";
    if(node.tagName === "IMG")return node.currentSrc || node.src || node.getAttribute("data-src") || node.getAttribute("data-lazy-src") || node.getAttribute("data-original") || "";
    for(var attrs = ["data-src", "data-image", "data-image-url", "data-original", "data-lazy-src", "data-bg", "data-background"], i = 0; i < attrs.length; i++){
      var val = node.getAttribute && node.getAttribute(attrs[i]);
      if(val && /^https?:|^\/|^\/\//.test(val))return val
    }
    var inlineBg = node.style && node.style.backgroundImage, u = cssUrl(inlineBg);
    if(u)return u;
    try{
      if(u = cssUrl(getComputedStyle(node).backgroundImage), u)return u
    }
    catch(e){
    }
    return""
  }
  function isUtilityIcon(node){
    var descriptor = ((node.className || "") + " " + (node.id || "") + " " + (node.getAttribute && node.getAttribute("alt") || "") + " " + (node.getAttribute && node.getAttribute("title") || "")).toLowerCase();
    return/tooltip|info|question|help|icon-info|fa-info/.test(descriptor)
  }
  function mediaCandidates(scope){
    if(!scope)return[];
    var nodes = [scope].concat(qa("img,[style*='background'],[data-src],[data-image],[data-image-url],[data-original],[data-lazy-src],[data-bg],[data-background]", scope)), results = [];
    return nodes.forEach(function(node){
      if(!(!node || isUtilityIcon(node))){
        var urls = [mediaUrl(node), pseudoMediaUrl(node, "::before"), pseudoMediaUrl(node, "::after")].filter(Boolean);
        urls.forEach(function(url){
          var lower = String(url).toLowerCase();
          /tooltip|info-icon|question|help-icon|icon-info/.test(lower) || results.some(function(x){
            return x.url === url
          }) || results.push({
            node: node, url: url
          })
        })
      }
    }), results
  }
  function scopeHasSingleChoice(scope, root){
    if(!scope)return!1;
    var inputs = sourceInputs(scope);
    if(inputs.length === 1)return!0;
    var optionInputs = sourceInputs(root), inside = optionInputs.filter(function(input){
      return scope.contains(input)
    });
    return inside.length === 1
  }
  function exactChoiceScopes(input, root){
    var scopes = [];
    function add(node){
      !node || node === document.body || scopes.indexOf(node) === - 1 && scopes.push(node)
    }
    var label = labelForInput(input, root);
    add(label), input && (add(input.parentElement), add(input.previousElementSibling), add(input.nextElementSibling), input.parentElement && (add(input.parentElement.previousElementSibling), add(input.parentElement.nextElementSibling)));
    for(var p = input?input.parentElement: null, i = 0; i < 6 && p && p !== root && p !== document.body; i++, p = p.parentElement)scopeHasSingleChoice(p, root) && add(p);
    return scopes
  }
  function bestMediaFromScope(scope){
    var candidates = mediaCandidates(scope);
    return candidates.length?(candidates.sort(function(a, b){
      function score(item){
        var node = item.node, s = 0;
        node && node.tagName === "IMG" && (s += 100);
        var desc = ((node && node.className || "") + " " + (node && node.id || "")).toLowerCase();
        if(/swatch|image|img|option|thumbnail|thumb/.test(desc) && (s += 25), node && node.getBoundingClientRect){
          var r = node.getBoundingClientRect();
          r.width >= 25 && r.height >= 25 && (s += 10)
        }
        return s
      }
      return score(b) - score(a)
    }), candidates[0].url || ""): ""
  }
  function findMediaForInput(input, root){
    for(var scopes = exactChoiceScopes(input, root), i = 0; i < scopes.length; i++){
      var url = bestMediaFromScope(scopes[i]);
      if(url)return url
    }
    return""
  }
  function findMediaForValue(root, value, index){
    var inputs = sourceInputs(root);
    if(inputs.length){
      var input = inputs.find(function(x){
        return String(x.value) === String(value)
      });
      if(input)return findMediaForInput(input, root)
    }
    return""
  }
  function parsePrice(text){
    var m = String(text || "").match(/([+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?)/);
    if(!m)return"";
    var s = m[1].replace(/\s+/g, ""), amount = parseFloat(s.replace(/[+$,]/g, ""));
    return!isNaN(amount) && amount === 0?"Included": (s.charAt(0) === "$" && (s = "+" + s), s)
  }
  function choices(root){
    if(!root)return[];
    var sel = sourceSelect(root);
    if(sel)return qa("option", sel).filter(function(o){
      return o.value !== ""
    }).map(function(o, index){
      return{
        value: o.value, label: o.value, price: parsePrice(o.textContent), image: findMediaForValue(root, o.value, index), selected: o.selected
      }
    });
    var inputs = sourceInputs(root);
    return inputs.map(function(input, index){
      var c = choiceContainer(input, root);
      return{
        value: input.value, label: input.value, price: parsePrice(c && c.textContent), image: findMediaForValue(root, input.value, index), selected: !!input.checked
      }
    })
  }
  function current(root){
    if(!root)return"";
    var sel = sourceSelect(root);
    if(sel)return sel.value || "";
    var checked = q('input[type="radio"]:checked,input[type="checkbox"]:checked', root);
    return checked?checked.value: ""
  }
  function setSelectChoice(sel, wanted){
    if(!sel)return!1;
    var wantedNorm = normalizeAccessoryValue(wanted), opts = qa("option", sel), match = opts.find(function(opt){
      return normalizeAccessoryValue(opt.value) === wantedNorm
    });
    if(match || (match = opts.find(function(opt){
      var txt = normalizeAccessoryValue(opt.textContent);
      return txt === wantedNorm || txt.indexOf(wantedNorm + " ") === 0 || txt.indexOf(wantedNorm + "+") === 0
    })), !match)return!1;
    if(opts.forEach(function(opt){
      opt.selected = opt === match
    }), sel.selectedIndex = opts.indexOf(match), sel.dispatchEvent(new Event("input", {
      bubbles: !0
    })), sel.dispatchEvent(new Event("change", {
      bubbles: !0
    })), window.jQuery && typeof window.jQuery == "function")try{
      window.jQuery(sel).trigger("change")
    }
    catch(e){
    }
    return delayedSync(), !0
  }
  function choose(root, value){
    if(root){
      var sel = sourceSelect(root);
      if(sel){
        setSelectChoice(sel, value);
        return
      }
      var input = sourceInputs(root).find(function(x){
        return String(x.value) === String(value)
      });
      input && (input.checked || input.click(), input.dispatchEvent(new Event("input", {
        bubbles: !0
      })), input.dispatchEvent(new Event("change", {
        bubbles: !0
      })), delayedSync())
    }
  }
  function clearChoice(root){
    if(!root)return!1;
    var sel = sourceSelect(root);
    if(sel){
      if(!sel.value)return!1;
      var blank = qa("option", sel).find(function(o){
        return o.value === ""
      });
      return blank?sel.value = "": sel.selectedIndex = - 1, sel.dispatchEvent(new Event("input", {
        bubbles: !0
      })), sel.dispatchEvent(new Event("change", {
        bubbles: !0
      })), delayedSync(), !0
    }
    var changed = !1;
    return sourceInputs(root).forEach(function(input){
      input.checked && (input.checked = !1, changed = !0, input.dispatchEvent(new Event("input", {
        bubbles: !0
      })), input.dispatchEvent(new Event("change", {
        bubbles: !0
      })))
    }), changed && delayedSync(), changed
  }
  function getState(){
    return{
      finish: current(refs.finish), grip: current(refs.grip), leatherWrap: current(refs.leatherWrap), leatherColor: current(refs.leatherColor), leatherTemplate: current(refs.leatherTemplate), stitching: current(refs.stitching), adapter: current(refs.adapter), hubSleeve: current(refs.hubSleeve), careKit: current(refs.careKit)
    }
  }
  function configuredPrice(){
    var txt = (document.body.innerText || "").replace(/\u00a0/g, " "), matches = txt.match(/Total price is\s*\$[\d,]+(?:\.\d{2})?/ig);
    if(matches && matches.length){
      var last = matches[matches.length - 1], m = last.match(/\$[\d,]+(?:\.\d{2})?/);
      if(m)return m[0]
    }
    return"\u2014"
  }
  function leadDebugEnabled(){
    try{
      return new URLSearchParams(window.location.search).get("sparc_lead_debug") === "1"
    }
    catch(e){
      return!1
    }
  }
  function ruleDebugRow(rule){
    return rule?{
      ruleName: rule.ruleName, scope: rule.seriesScope, productHandle: rule.productHandle, selectorId: rule.selectorId, optionValue: rule.optionValue, normalizedValue: normalizeRuleValue(rule.optionValue), minimum: rule.minimum, maximum: rule.maximum, unit: rule.unit, customerMessage: rule.customerMessage, valid: validLeadRule(rule)
    }: null
  }
  var leadTimeDataCache = null, leadTimeDataMissingLogged = !1;
  function leadTimeData(){
    if(leadTimeDataCache)return leadTimeDataCache;
    var node = document.getElementById("sparc-configurator-lead-time-data");
    if(!node)return leadTimeDataMissingLogged || (leadTimeDataMissingLogged = !0, console.warn("[SPARC DRIVER V1.14] Lead-time JSON bridge was not found on the page.")), null;
    try{
      return leadTimeDataCache = JSON.parse(node.textContent || "{}"), leadTimeDataCache.seriesScope = SERIES_SCOPE, leadTimeDataCache
    }
    catch(e){
      return console.error("[SPARC DRIVER V1.14] Lead-time JSON could not be parsed.", e), null
    }
  }
  function normalizeLeadUnit(unit){
    var u = String(unit || "").trim().toLowerCase();
    return u === "day" || u === "days"?"days": u === "week" || u === "weeks" || u === "wk" || u === "wks"?"weeks": ""
  }
  function normalizeSelectorId(value){
    return String(value || "").replace(/\u00a0/g, " ").trim().toLowerCase()
  }
  function normalizeRuleValue(value){
    if(value == null)return"";
    var text = String(value).replace(/\u00a0/g, " ").replace(/&nbsp;/gi, " ");
    return text = friendly(text), text = String(text).replace(/[[(|]?\s*[+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?\s*[\])|]?/g, " ").replace(/\s+[+\-]\s*[\d,]+(?:\.\d{1,2})?\s*$/g, " ").replace(/\s+/g, " ").trim().toLowerCase(), text = text.replace(/\s*[|•·]\s*/g, " ").replace(/\s+/g, " ").trim(), text
  }
  function ruleValueMatches(ruleValue, selectedValue){
    var rule = normalizeRuleValue(ruleValue), selected = normalizeRuleValue(selectedValue);
    return!rule || !selected?!1: rule === selected || selected.indexOf(rule + " ") === 0 || selected.indexOf(rule + " -") === 0 || selected.indexOf(rule + ":") === 0
  }
  function ruleComparisonDays(rule){
    var unit = normalizeLeadUnit(rule && rule.unit), min = Number(rule && rule.minimum) || 0, max = Number(rule && rule.maximum) || 0;
    return unit === "weeks" && (min *= 7, max *= 7), {
      min: min, max: max
    }
  }
  function validLeadRule(rule){
    if(!rule)return!1;
    var unit = normalizeLeadUnit(rule.unit), min = Number(rule.minimum), max = Number(rule.maximum);
    return!!(unit && isFinite(min) && isFinite(max) && min >= 0 && max >= min)
  }
  function ruleSpecificity(rule, data){
    if(!rule || !data)return - 1;
    var scope = String(rule.seriesScope || "").toLowerCase(), productHandle = String(rule.productHandle || "");
    return productHandle && productHandle === String(data.productHandle || "")?300: scope && scope === String(data.seriesScope || "").toLowerCase()?200: scope === "shared"?100: - 1
  }
  function matchingRule(selectorId, optionValue){
    var data = leadTimeData();
    if(!data || !Array.isArray(data.rules))return null;
    var selector = normalizeSelectorId(selectorId), selectorRules = data.rules.filter(function(rule){
      return validLeadRule(rule)?normalizeSelectorId(rule.selectorId) === selector && ruleSpecificity(rule, data) >= 0: !1
    }), matches = selectorRules.filter(function(rule){
      return ruleValueMatches(rule.optionValue, optionValue)
    });
    return matches.length?(matches.sort(function(a, b){
      return ruleSpecificity(b, data) - ruleSpecificity(a, data)
    }), matches[0]): (leadDebugEnabled() && console.warn("[SPARC DRIVER V1.14] No rule match", {
      selectorId: selectorId, selectedValue: optionValue, normalizedSelector: selector, normalizedSelectedValue: normalizeRuleValue(optionValue), candidateRules: selectorRules.map(function(rule){
        return{
          ruleName: rule.ruleName, selectorId: rule.selectorId, optionValue: rule.optionValue, normalizedOptionValue: normalizeRuleValue(rule.optionValue), min: rule.minimum, max: rule.maximum, unit: rule.unit
        }
      })
    }), null)
  }
  function baseLeadRule(){
    return matchingRule("base", "base")
  }
  function activeLeadSelections(s){
    var selections = [];
    function push(selectorId, value){
      value && selections.push({
        selectorId: selectorId, value: value
      })
    }
    push(IDS.finish, s.finish), push(IDS.grip, s.grip), push(IDS.leatherWrap, s.leatherWrap), refs.leatherColor && sourceVisible(refs.leatherColor) && push(IDS.leatherColor, s.leatherColor), refs.stitching && sourceVisible(refs.stitching) && push(IDS.stitching, s.stitching), refs.leatherTemplate && sourceVisible(refs.leatherTemplate) && push(IDS.leatherTemplate, s.leatherTemplate), push(IDS.adapter, s.adapter), refs.hubSleeve && sourceVisible(refs.hubSleeve) && push(IDS.hubSleeve, s.hubSleeve), refs.careKit && sourceVisible(refs.careKit) && valueEquals(s.careKit, "Yes") && push(IDS.careKit, s.careKit);
    return selections
  }
  function activeLeadMessages(s){
    var data = leadTimeData();
    if(!data || !Array.isArray(data.rules))return[];
    var selections = activeLeadSelections(s), messages = [];
    function addMessage(rule){
      if(rule){
        var message = clean(rule.customerMessage || "");
        message && messages.indexOf(message) === - 1 && messages.push(message)
      }
    }
    return selections.forEach(function(selection){
      var selector = normalizeSelectorId(selection.selectorId);
      data.rules.forEach(function(rule){
        rule && (ruleSpecificity(rule, data) < 0 || normalizeSelectorId(rule.selectorId) === selector && ruleValueMatches(rule.optionValue, selection.value) && addMessage(rule))
      })
    }), data.rules.forEach(function(rule){
      rule && (ruleSpecificity(rule, data) < 0 || normalizeSelectorId(rule.selectorId) === normalizeSelectorId("base") && ruleValueMatches(rule.optionValue, "base") && addMessage(rule))
    }), messages
  }
  function leadQualifier(s){
    return activeLeadMessages(s).join(" \u2022 ")
  }
  function winningLeadRule(s){
    var candidates = [], base = baseLeadRule();
    return base && candidates.push(base), activeLeadSelections(s).forEach(function(selection){
      var rule = matchingRule(selection.selectorId, selection.value);
      rule && candidates.push(rule)
    }), candidates.length?(candidates.sort(function(a, b){
      var ac = ruleComparisonDays(a), bc = ruleComparisonDays(b);
      return bc.max !== ac.max?bc.max - ac.max: bc.min !== ac.min?bc.min - ac.min: ruleSpecificity(b, leadTimeData()) - ruleSpecificity(a, leadTimeData())
    }), candidates[0]): null
  }
  function formatLeadRule(rule){
    if(!validLeadRule(rule))return"\u2014";
    var min = Number(rule.minimum), max = Number(rule.maximum), unit = normalizeLeadUnit(rule.unit);
    return unit === "days"?min === max?min === 1?"1 DAY": min + " DAYS": min + "\u2013" + max + " DAYS": unit === "weeks"?min === max?min === 1?"1 WK": min + " WKS": min + "\u2013" + max + " WKS": "\u2014"
  }
  function leadTime(s){
    var winner = winningLeadRule(s);
    return winner?formatLeadRule(winner): (leadTimeData() && console.warn("[SPARC DRIVER V1.14] Lead-time rules loaded, but no applicable rule was found. Check the active Driver Series Base metaobject."), "\u2014")
  }
  function renderLeadDebug(){
    if(leadDebugEnabled()){
      var existing = document.getElementById("sparc-lead-debug");
      existing && existing.remove();
      var data = leadTimeData(), state = getState(), selections = activeLeadSelections(state), box = el("div", "");
      box.id = "sparc-lead-debug", box.style.cssText = "margin:12px 0;padding:12px 14px;border:2px solid #a8874a;background:#fff8ea;color:#222;font:11px/1.45 Arial,sans-serif;";
      var html = "<strong>SPARC V36 Lead-Time Debug</strong>";
      data || (html += "<br><br><b>ERROR:</b> Lead-time JSON bridge is missing from the page."), html += "<br><br><b>Winning rule:</b><br><pre style='white-space:pre-wrap'>" + JSON.stringify(ruleDebugRow(winningLeadRule(state)), null, 2).replace(/</g, "&lt;") + "</pre>", html += "<b>Active selections:</b><br><pre style='white-space:pre-wrap'>" + JSON.stringify(selections.map(function(sel){
        var matched = matchingRule(sel.selectorId, sel.value);
        return{
          selectorId: sel.selectorId, rawValue: sel.value, normalizedValue: normalizeRuleValue(sel.value), matchedRule: matched?ruleDebugRow(matched): null
        }
      }), null, 2).replace(/</g, "&lt;") + "</pre>", html += "<b>Loaded rules:</b><br><pre style='white-space:pre-wrap'>" + JSON.stringify(data && data.rules?data.rules.map(ruleDebugRow): [], null, 2).replace(/</g, "&lt;") + "</pre>", box.innerHTML = html;
      var mount = document.getElementById("sparc-driver-configurator-mount");
      mount && mount.parentNode && mount.parentNode.insertBefore(box, mount)
    }
  }
  function currentLeadTimeRule(){
    return winningLeadRule(getState())
  }
  var optionDetailDataCache = null;
  function optionDetailData(){
    if(optionDetailDataCache)return optionDetailDataCache;
    var node = document.getElementById("sparc-configurator-option-detail-data");
    if(!node)return null;
    try{
      return optionDetailDataCache = JSON.parse(node.textContent || "{}"), optionDetailDataCache.seriesScope = SERIES_SCOPE, optionDetailDataCache
    }
    catch(e){
      return console.error("[SPARC DRIVER V1.14] Option-detail JSON could not be parsed.", e), null
    }
  }
  function optionDetailSpecificity(detail, data){
    if(!detail || !data)return - 1;
    var scope = String(detail.seriesScope || "").toLowerCase(), productHandle = String(detail.productHandle || "");
    return productHandle && productHandle === String(data.productHandle || "")?300: scope && scope === String(data.seriesScope || "").toLowerCase()?200: scope === "shared"?100: - 1
  }
  function matchingOptionDetail(selectorId, optionValue){
    var data = optionDetailData();
    if(!data || !Array.isArray(data.entries))return null;
    var selector = normalizeSelectorId(selectorId), matches = data.entries.filter(function(detail){
      return!detail || detail.enabled !== !0 || normalizeSelectorId(detail.selectorId) !== selector || !ruleValueMatches(detail.optionValue, optionValue)?!1: optionDetailSpecificity(detail, data) >= 0
    });
    return matches.length?(matches.sort(function(a, b){
      return optionDetailSpecificity(b, data) - optionDetailSpecificity(a, data)
    }), matches[0]): null
  }
  function selectorImageForOption(root, value, fallbackImage){
    var detail = matchingOptionDetail(root && root.id, value);
    return fallbackImage || detail && detail.selectorImage || ""
  }
  function popupImagesForOption(root, value, fallbackImage){
    var detail = matchingOptionDetail(root && root.id, value), images = [];
    return detail && detail.popupImage?images.push(detail.popupImage): detail && detail.selectorImage?images.push(detail.selectorImage): fallbackImage && images.push(fallbackImage), detail && Array.isArray(detail.popupAdditionalImages) && detail.popupAdditionalImages.forEach(function(url){
      url && images.indexOf(url) === - 1 && images.push(url)
    }), images
  }
  function accordion(name, num, title){
    var section = el("section", "sparc-accordion");
    section.dataset.section = name;
    var head = el("button", "sparc-accordion__head");
    head.type = "button", head.appendChild(el("span", "sparc-step-number", num)), head.appendChild(el("span", "sparc-accordion__title", title)), head.appendChild(el("span", "sparc-required-badge", "REQUIRED")), head.appendChild(el("span", "sparc-accordion__summary", "")), head.appendChild(el("span", "sparc-chevron", "\u2304"));
    var body = el("div", "sparc-accordion__body"), inner = el("div", "sparc-accordion__inner");
    return body.appendChild(inner), section.appendChild(head), section.appendChild(body), head.addEventListener("click", function(e){
      e.preventDefault(), e.stopPropagation(), section.classList.contains("is-open")?closeAll(): openSection(name)
    }), {
      section: section, inner: inner
    }
  }
  function makeTab(name, text){
    var b = el("button", "sparc-config-tab", text);
    return b.type = "button", b.addEventListener("click", function(e){
      e.preventDefault(), e.stopPropagation(), openSection(name)
    }), tabs[name] = b, b
  }
  function closeAll(){
    Object.keys(accs).forEach(function(k){
      accs[k].section && accs[k].section.classList.remove("is-open")
    }), Object.keys(tabs).forEach(function(k){
      tabs[k].classList.remove("is-active")
    }), scheduleResize()
  }
  function openSection(name){
    Object.keys(accs).forEach(function(k){
      accs[k].section && accs[k].section.classList.toggle("is-open", k === name)
    }), Object.keys(tabs).forEach(function(k){
      tabs[k].classList.toggle("is-active", k === name)
    }), scheduleResize()
  }
  function optionInfoCopy(sectionName, value){
    var val = friendly(value);
    return sectionName === "finish"?"See a larger view of " + val + " and compare how this finish changes the appearance of the billet center and spokes.": sectionName === "grip"?"See a larger view of the " + val + " grip profile. Use the enlarged image to compare the hand position, upper-grip geometry, and overall shape.": sectionName === "leather"?"See more detail for " + val + ". Leather and grip-finish selections affect both the appearance and final feel of the steering wheel.": sectionName === "horn"?"See more detail for the " + val + " horn-button treatment and how it affects the finished center appearance.": sectionName === "mounting"?"See more information about " + val + " and how this mounting choice relates to steering-column fitment.": sectionName === "accessories"?"See more information about " + val + ", including fitment, finish, and how this optional accessory works with your steering wheel package.": "More information about " + val + "."
  }
  function sectionNameForRoot(root){
    return root === refs.finish?"finish": root === refs.grip?"grip": root === refs.leatherWrap || root === refs.leatherColor?"leather": root === refs.hornLogo?"horn": root === refs.adapter || root === refs.hubSleeve?"mounting": root === refs.columnSpacer || root === refs.columnSpacerFinish || root === refs.careKit?"accessories": ""
  }
  function addOptionInfoButton(container, root, value, imageUrl){
    if(!(!container || !root)){
      var sectionName = sectionNameForRoot(root);
      if(sectionName){
        var button = el("button", "sparc-option-info", "i");
        button.type = "button", button.setAttribute("aria-label", "More information about " + friendly(value)), button.addEventListener("click", function(e){
          e.preventDefault(), e.stopPropagation();
          var detail = matchingOptionDetail(root.id, value);
          openOptionInfoModal({
            section: sectionName, root: root, value: value, fallbackImage: imageUrl || "", detail: detail
          })
        }), container.appendChild(button)
      }
    }
  }
  function setInfoModalGallery(modal, images, altText){
    var main = q(".sparc-info-modal__image", modal), strip = q(".sparc-info-modal__thumbs", modal);
    if(images = Array.isArray(images)?images.filter(Boolean): [], strip.innerHTML = "", !images.length){
      main.removeAttribute("src"), main.classList.remove("has-image"), strip.classList.remove("has-images");
      return
    }
    main.src = images[0], main.alt = altText || "", main.classList.add("has-image"), images.length > 1?(strip.classList.add("has-images"), images.forEach(function(url, index){
      var button = el("button", "sparc-info-modal__thumb", "");
      button.type = "button", button.classList.toggle("is-active", index === 0);
      var img = document.createElement("img");
      img.src = url, img.alt = altText?altText + " view " + (index + 1): "Option detail view " + (index + 1), button.appendChild(img), button.addEventListener("click", function(){
        main.src = url, qa(".sparc-info-modal__thumb", strip).forEach(function(node){
          node.classList.remove("is-active")
        }), button.classList.add("is-active")
      }), strip.appendChild(button)
    })): strip.classList.remove("has-images")
  }
  function openOptionInfoModal(data){
    var modal = ensureInfoModal(), sectionContent = INFO_CONTENT[data.section] || {
    }, detail = data.detail || matchingOptionDetail(data.root && data.root.id, data.value);
    q(".sparc-info-modal__eyebrow", modal).textContent = sectionContent.eyebrow || "Option Information", q(".sparc-info-modal__title", modal).textContent = detail && detail.popupTitle?detail.popupTitle: friendly(data.value), q(".sparc-info-modal__selection", modal).textContent = detail && detail.popupDescriptionHeading?detail.popupDescriptionHeading: "OPTION DETAILS";
    var copy = q(".sparc-info-modal__copy", modal);
    detail && detail.popupDescriptionHtml?copy.innerHTML = detail.popupDescriptionHtml: copy.textContent = optionInfoCopy(data.section, data.value);
    var images = popupImagesForOption(data.root, data.value, data.fallbackImage);
    modal.classList.remove("sparc-driver-v13-sidebar-hidden"), setInfoModalGallery(modal, images, detail && detail.imageAltText?detail.imageAltText: friendly(data.value)), modal.classList.add("is-open"), modal.setAttribute("aria-hidden", "false"), document.body.classList.add("sparc-modal-open")
  }
  function cardGrid(root, cols, isGrip, placeholder){
    var wrap = el("div", "sparc-card-grid " + (cols === 3?"sparc-card-grid--3": "sparc-card-grid--2"));
    return choices(root).forEach(function(c){
      var detail = matchingOptionDetail(root.id, c.value), cardImage = selectorImageForOption(root, c.value, c.image), b = el("button", "sparc-option-card");
      b.type = "button", b.dataset.value = c.value, b.dataset.sourceId = root.id, b.appendChild(el("span", "sparc-option-card__check", "\u2713")), addOptionInfoButton(b, root, c.value, cardImage);
      var iw = el("div", "sparc-option-card__image" + (isGrip?" sparc-option-card__image--grip": ""));
      if(cardImage){
        var im = document.createElement("img");
        im.src = cardImage, im.alt = detail && detail.imageAltText?detail.imageAltText: friendly(c.value), iw.appendChild(im)
      }
      else iw.appendChild(el("div", "sparc-option-card__placeholder", placeholder || "Add option image in Hulk Admin"));
      b.appendChild(iw);
      var cp = el("div", "sparc-option-card__copy");
      cp.appendChild(el("span", "sparc-option-card__name", friendly(c.value)));
      var meta = el("div", "sparc-option-card__meta");
      meta.appendChild(el("span", "sparc-option-card__note", ""));
      var displayPrice = c.price || "";
      !displayPrice && root && root.id === IDS.finish && normalizeAccessoryValue(c.value) === "machine finish" && (displayPrice = "Included"), meta.appendChild(el("span", "sparc-option-card__price", displayPrice)), cp.appendChild(meta), b.appendChild(cp), b.addEventListener("click", function(e){
        e.preventDefault(), e.stopPropagation(), choose(root, c.value)
      }), wrap.appendChild(b)
    }), wrap
  }
  function optionalAccessoryToggleCard(root, yesValue, noValue, title, description){
    var wrap = el("div", "sparc-accessory-toggle-grid"), yesChoice = choices(root).find(function(c){
      return valueEquals(c.value, yesValue)
    });
    if(!yesChoice)return wrap;
    var detail = matchingOptionDetail(root.id, yesChoice.value), cardImage = selectorImageForOption(root, yesChoice.value, yesChoice.image), button = el("button", "sparc-option-card sparc-accessory-toggle-card");
    button.type = "button", button.dataset.value = yesChoice.value, button.dataset.sourceId = root.id, button.appendChild(el("span", "sparc-option-card__check", "\u2713")), addOptionInfoButton(button, root, yesChoice.value, cardImage);
    var iw = el("div", "sparc-option-card__image sparc-accessory-toggle-card__image");
    if(cardImage){
      var im = document.createElement("img");
      im.src = cardImage, im.alt = detail && detail.imageAltText?detail.imageAltText: title, iw.appendChild(im)
    }
    else iw.appendChild(el("div", "sparc-option-card__placeholder", "Add care kit image in Hulk Admin"));
    button.appendChild(iw);
    var cp = el("div", "sparc-option-card__copy");
    cp.appendChild(el("span", "sparc-option-card__name", title)), description && cp.appendChild(el("span", "sparc-accessory-toggle-card__description", description));
    var meta = el("div", "sparc-option-card__meta");
    return meta.appendChild(el("span", "sparc-option-card__note", "Optional")), meta.appendChild(el("span", "sparc-option-card__price", yesChoice.price || "")), cp.appendChild(meta), button.appendChild(cp), button.dataset.accessoryKey = "careKit", button.addEventListener("click", function(e){
      if(!e.__sparcCareHandled){
        e.preventDefault(), e.stopPropagation();
        var liveRoot = currentAccessoryRoot("careKit");
        if(liveRoot){
          var nextValue = valueEquals(current(liveRoot), yesValue)?noValue: yesValue;
          choose(liveRoot, nextValue), requestAnimationFrame(function(){
            var currentRoot = currentAccessoryRoot("careKit");
            currentRoot && syncChoiceClasses(currentRoot, accs.accessories.section)
          })
        }
      }
    }), wrap.appendChild(button), wrap
  }
  function choiceGrid(root, metaMap){
    var wrap = el("div", "sparc-choice-grid");
    return choices(root).forEach(function(c){
      var m = metaMap && metaMap[c.value] || {
      }, b = el("button", "sparc-choice");
      b.type = "button", b.dataset.value = c.value, b.dataset.sourceId = root.id, b.appendChild(el("span", "sparc-choice__title", m.title || friendly(c.value))), b.appendChild(el("span", "sparc-choice__sub", m.sub || c.price || "")), b.addEventListener("click", function(e){
        e.preventDefault(), e.stopPropagation(), choose(root, c.value)
      }), wrap.appendChild(b)
    }), wrap
  }
  function stitchGrid(root){
    var wrap = el("div", "sparc-stitch-grid");
    return choices(root).forEach(function(c){
      var b = el("button", "sparc-stitch");
      b.type = "button", b.dataset.value = c.value, b.dataset.sourceId = root.id;
      var t = el("span", "sparc-stitch__thread");
      t.style.background = STITCH_COLORS[c.value] || "#777", b.appendChild(t), b.appendChild(el("span", "sparc-stitch__name", c.value)), b.addEventListener("click", function(e){
        e.preventDefault(), e.stopPropagation(), choose(root, c.value)
      }), wrap.appendChild(b)
    }), wrap
  }
  function mirrorSelect(root, labelText, help){
    var field = el("div", "sparc-field");
    field.appendChild(el("label", "sparc-field__label", labelText));
    var mirror = document.createElement("select");
    mirror.className = "sparc-select";
    var ss = sourceSelect(root);
    return ss && (qa("option", ss).forEach(function(o){
      var op = document.createElement("option");
      op.value = o.value, op.textContent = o.textContent, mirror.appendChild(op)
    }), mirror.value = ss.value, mirror.addEventListener("change", function(e){
      e.stopPropagation(), choose(root, mirror.value)
    })), field.appendChild(mirror), help && field.appendChild(el("div", "sparc-field__help", help)), field._mirror = mirror, field
  }
  function conditional(){
    var o = el("div", "sparc-conditional");
    return o.appendChild(el("div", "sparc-conditional__inner")), o
  }
  function hideLegacyDecorations(){
    qa("*", document).forEach(function(n){
      panel && panel.contains(n) || (n.children.length <= 1 && /^Choose Your Product Options:?$/i.test(clean(n.textContent)) && n.classList.add("sparc-source-decoration-hidden"), n.children.length <= 3 && /^Total price is\s*\$[\d,]+(?:\.\d{2})?$/i.test(clean(n.textContent)) && n.classList.add("sparc-source-decoration-hidden"))
    })
  }
  function debugImageData(){
    var params = new URLSearchParams(window.location.search);
    if(params.get("sparc_debug") !== "1")return;
    var old = document.getElementById("sparc-image-debug");
    old && old.remove();
    var box = el("div", "");
    box.id = "sparc-image-debug";
    function rows(root, title){
      var html = "<strong>" + title + "</strong>", ch = choices(root), inputs = sourceInputs(root);
      return ch.forEach(function(c){
        var input = inputs.find(function(x){
          return String(x.value) === String(c.value)
        }), label = input?labelForInput(input, root): null;
        if(html += "<code>" + c.value.replace(/</g, "&lt;") + " -> " + (c.image?c.image.replace(/</g, "&lt;"): "[NO EXACT IMAGE URL FOUND]") + "</code><br>", !c.image && label){
          var snippet = label.outerHTML || "";
          snippet = snippet.slice(0, 900).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), html += "<code>label HTML: " + snippet + "</code><br>"
        }
      }), html
    }
    box.innerHTML = "<b>SPARC V23 Exact Hulk Image Debug</b>" + rows(refs.finish, "Finish") + rows(refs.grip, "Grip") + rows(refs.leatherColor, "Leather Color");
    var mount = document.getElementById("sparc-driver-configurator-mount");
    mount && mount.parentNode && mount.parentNode.insertBefore(box, mount), console.info("[SPARC DRIVER V1.14] Finish media", choices(refs.finish)), console.info("[SPARC DRIVER V1.14] Grip media", choices(refs.grip)), console.info("[SPARC DRIVER V1.14] Leather Color media", choices(refs.leatherColor))
  }
  function findCustomLaserFileSource(){
    var files = qa('input[type="file"]', document);
    if(!files.length)return null;
    var candidates = files.map(function(input){
      var score = 0, p = input.parentElement, bestWrapper = input.parentElement, descriptor = clean((input.name || "") + " " + (input.id || "") + " " + (input.className || "") + " " + (input.getAttribute("data-name") || "") + " " + (input.getAttribute("data-label") || "")).toLowerCase();
      /custom laser marking/.test(descriptor) && (score += 200), /laser|marking/.test(descriptor) && (score += 90), /custom|logo/.test(descriptor) && (score += 50);
      for(var i = 0; i < 8 && p && p !== document.body; i++, p = p.parentElement){
        var text = clean(p.textContent).toLowerCase();
        /custom laser marking/.test(text)?score += 180: /laser.*mark|custom.*mark/.test(text)?score += 100: /laser|marking|custom logo/.test(text) && (score += 35), bestWrapper && clean(p.textContent).length && clean(p.textContent).length < clean(bestWrapper.textContent).length && (bestWrapper = p)
      }
      return{
        input: input, wrapper: bestWrapper || input.parentElement, score: score
      }
    });
    return candidates.sort(function(a, b){
      return b.score - a.score
    }), candidates[0] && (candidates[0].score > 0 || files.length === 1)?candidates[0]: null
  }
  function customUploadBlock(){
    var outer = el("div", "sparc-custom-upload is-hidden");
    outer.appendChild(el("span", "sparc-custom-upload__label", "CUSTOM HORN LOGO ARTWORK")), outer.appendChild(el("div", "sparc-custom-upload__help", "Upload the artwork file SPARC should use for your custom horn-button laser marking. Vector artwork is preferred when available."));
    var input = document.createElement("input");
    input.type = "file", input.className = "sparc-custom-upload__input", input.accept = ".ai,.eps,.svg,.pdf,.png,.jpg,.jpeg";
    var status = el("div", "sparc-custom-upload__status", "No file selected");
    return outer.appendChild(input), outer.appendChild(status), outer._sparcProxyInput = input, outer._sparcStatus = status, outer._sparcProxyFile = null, outer._sparcFileInput = null, outer._sparcSourceWrapper = null, input.addEventListener("change", function(){
      if(outer._sparcProxyFile = input.files && input.files.length?input.files[0]: null, status.classList.remove("is-ok", "is-error"), !outer._sparcProxyFile){
        status.textContent = "No file selected", sparcValidationAttempted && applyValidationState();
        return
      }
      status.textContent = outer._sparcProxyFile.name;
      function finishStatus(ok){
        status.classList.remove("is-ok", "is-error"), ok?(status.classList.add("is-ok"), status.textContent = outer._sparcProxyFile.name + " \xB7 ready"): status.textContent = outer._sparcProxyFile.name + " \xB7 connecting to product upload field\u2026", sparcValidationAttempted && applyValidationState()
      }
      var synced = syncProxyFileToHulk();
      finishStatus(synced), synced || (setTimeout(function(){
        finishStatus(syncProxyFileToHulk())
      }, 150), setTimeout(function(){
        finishStatus(syncProxyFileToHulk())
      }, 500), setTimeout(function(){
        finishStatus(syncProxyFileToHulk())
      }, 1e3))
    }), outer
  }
  function customFileVisualWrapper(input){
    if(!input)return null;
    for(var p = input.parentElement, fallback = p, i = 0; i < 8 && p && p !== document.body; i++, p = p.parentElement){
      var text = clean(p.textContent);
      if(/Custom Laser Marking/i.test(text))return p;
      p.contains(input) && (fallback = p)
    }
    return fallback
  }
  function setInputFiles(input, file){
    if(!input || !file)return!1;
    try{
      var dt = new DataTransfer;
      return dt.items.add(file), input.files = dt.files, input.dispatchEvent(new Event("input", {
        bubbles: !0
      })), input.dispatchEvent(new Event("change", {
        bubbles: !0
      })), !!(input.files && input.files.length && input.files[0].name === file.name)
    }
    catch(e){
      return console.warn("[SPARC DRIVER V1.14] Could not mirror file into Hulk input", e), !1
    }
  }
  function syncProxyFileToHulk(){
    if(!accs.customLaserBlock)return!1;
    var file = accs.customLaserBlock._sparcProxyFile;
    if(!file)return!1;
    var source = findCustomLaserFileSource();
    if(!source || !source.input)return!1;
    var input = source.input, wrapper = customFileVisualWrapper(input);
    accs.customLaserBlock._sparcFileInput = input, accs.customLaserBlock._sparcSourceWrapper = wrapper, wrapper && !panel.contains(wrapper) && !wrapper.classList.contains("sparc-custom-file-source-hidden") && wrapper.classList.add("sparc-custom-file-source-hidden");
    var ok = setInputFiles(input, file), status = accs.customLaserBlock._sparcStatus;
    return status && (status.classList.remove("is-ok", "is-error"), ok?(status.classList.add("is-ok"), status.textContent = file.name + " \xB7 ready"): (status.classList.add("is-error"), status.textContent = file.name + " \xB7 upload field not ready")), ok
  }
  function watchForCustomUpload(){
  }
  function connectCustomLaserUpload(){
    if(!accs.customLaserBlock)return!1;
    var source = findCustomLaserFileSource();
    if(!source || !source.input)return!1;
    var input = source.input, wrapper = customFileVisualWrapper(input);
    return accs.customLaserBlock._sparcFileInput = input, accs.customLaserBlock._sparcSourceWrapper = wrapper, wrapper && !panel.contains(wrapper) && !wrapper.classList.contains("sparc-custom-file-source-hidden") && wrapper.classList.add("sparc-custom-file-source-hidden"), accs.customLaserBlock._sparcProxyFile?syncProxyFileToHulk(): !0
  }
  function adapterSvg(label){
    var years = String(label || "").match(/\d{2}[-–]\d{2}/), yr = years?years[0]: "";
    return'<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="50" cy="50" r="31" stroke-width="5"/><circle cx="50" cy="50" r="13" stroke-width="4"/><path d="M50 19V36M50 64V81M19 50H36M64 50H81" stroke-width="4" stroke-linecap="round"/><path d="M30 30L41 41M59 59L70 70M70 30L59 41M41 59L30 70" stroke-width="3" stroke-linecap="round"/>' + (yr?'<text x="50" y="96" text-anchor="middle" fill="#55514b" stroke="none" font-size="12" font-family="Arial" font-weight="700">' + yr + "</text>": "") + "</svg>"
  }
  function isYesValue(value){
    return/^yes\b/i.test(clean(value))
  }
  function sleeveSvg(hasSleeve){
    return hasSleeve?'<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><ellipse cx="50" cy="25" rx="25" ry="11" stroke-width="4"/><path d="M25 25V70C25 77 36 83 50 83C64 83 75 77 75 70V25" stroke-width="4"/><ellipse cx="50" cy="70" rx="25" ry="11" stroke-width="4"/><ellipse cx="50" cy="25" rx="12" ry="5" stroke-width="3"/></svg>': '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><ellipse cx="50" cy="32" rx="24" ry="10" stroke-width="4"/><path d="M26 32V67C26 73 37 78 50 78C63 78 74 73 74 67V32" stroke-width="4"/><ellipse cx="50" cy="67" rx="24" ry="10" stroke-width="4"/><path d="M23 23L77 77" stroke="#9c2e24" stroke-width="7" stroke-linecap="round"/></svg>'
  }
  function visualMountingGrid(root, kind){
    /*
     * Mounting options use the exact same image-card component as Finish,
     * Grip and Leather Color. Hulk supplies the swatch image; the SPARC
     * configurator only presents that source option.
     */
    return cardGrid(root, 2, !1)
  }
  var INFO_CONTENT = {
    finish: {
      eyebrow: "01 \xB7 Finish",
      title: "Steering Wheel Finish",
      copy: "Choose the finish for the Driver Series center and spoke assembly. Compare the available finishes and any price difference before making your selection."
    },
    grip: {
      eyebrow: "02 \xB7 Grip",
      title: "Grip Style",
      copy: "Choose between the Driver Series D Smooth and D 10/2 grip profiles. Compare the shape before selecting the grip finish or leather treatment."
    },
    leather: {
      eyebrow: "03 \xB7 Grip Finish",
      title: "Leather & Grip Finish",
      copy: "Choose whether the Driver grip will be leather wrapped or left in its raw finish. Leather builds require leather color and stitching; raw builds use the applicable Driver template."
    },
    mounting: {
      eyebrow: "04 \xB7 Mounting",
      title: "Mounting & Fitment",
      copy: "Choose the Driver Series column adapter and whether to include a hub sleeve. No Adapter is a valid selection when an adapter is not required."
    },
    accessories: {
      eyebrow: "05 \xB7 Accessories",
      title: "Optional Accessories",
      copy: "Add compatible optional accessories to the Driver Series package. The shared Steering Wheel Care Kit can be added independently and is not required."
    },
    summary: {
      eyebrow: "Build Review",
      title: "Configuration Summary",
      copy: "Review the complete Driver Series build before adding it to your cart."
    }
  };

  function currentSectionImage(name){
    var section = accs[name] && accs[name].section;
    if(!section)return"";
    var selected = q(".sparc-option-card.is-selected img", section) || q(".sparc-option-card img", section);
    return selected && (selected.currentSrc || selected.src) || ""
  }
  function currentSectionSelection(name){
    var s = getState();
    if(name === "finish")return friendly(s.finish);
    if(name === "grip")return friendly(s.grip);
    if(name === "leather"){
      var leatherParts = [];
      s.leatherWrap && leatherParts.push(friendly(s.leatherWrap)), refs.leatherColor && sourceVisible(refs.leatherColor) && s.leatherColor && leatherParts.push(friendly(s.leatherColor)), refs.stitching && sourceVisible(refs.stitching) && s.stitching && leatherParts.push(friendly(s.stitching) + " Stitch"), refs.leatherTemplate && sourceVisible(refs.leatherTemplate) && s.leatherTemplate && leatherParts.push(friendly(s.leatherTemplate));
      return leatherParts.join(" \xB7 ")
    }
    return name === "mounting"?[s.adapter, refs.hubSleeve && sourceVisible(refs.hubSleeve) && s.hubSleeve?"Sleeve " + s.hubSleeve: ""].filter(Boolean).map(friendly).join(" \xB7 "): name === "accessories"?valueEquals(s.careKit, "Yes")?"Steering Wheel Care Kit": "None": ""
  }
  function ensureInfoModal(){
    var existing = document.getElementById("sparc-info-modal");
    if(existing){
      /*
       * Driver's desktop-width cleanup hides siblings of #MainContent.
       * If the shared option-detail modal already exists at that time, it
       * can inherit the same hidden class as the old Supply sidebar.
       * Never allow the option-detail modal to remain in that hidden set.
       */
      existing.classList.remove("sparc-driver-v13-sidebar-hidden");
      return existing;
    }
    var modal = el("div", "");
    modal.id = "sparc-info-modal", modal.setAttribute("aria-hidden", "true");
    var backdrop = el("div", "sparc-info-modal__backdrop", "");
    modal.appendChild(backdrop);
    var dialog = el("div", "sparc-info-modal__dialog", "");
    dialog.setAttribute("role", "dialog"), dialog.setAttribute("aria-modal", "true");
    var head = el("div", "sparc-info-modal__head", ""), titleWrap = el("div", "", "");
    titleWrap.appendChild(el("span", "sparc-info-modal__eyebrow", "")), titleWrap.appendChild(el("h2", "sparc-info-modal__title", ""));
    var close = el("button", "sparc-info-modal__close", "\xD7");
    close.type = "button", close.setAttribute("aria-label", "Close information popup"), head.appendChild(titleWrap), head.appendChild(close), dialog.appendChild(head);
    var body = el("div", "sparc-info-modal__body", ""), image = document.createElement("img");
    image.className = "sparc-info-modal__image", body.appendChild(image), body.appendChild(el("div", "sparc-info-modal__thumbs", "")), body.appendChild(el("div", "sparc-info-modal__selection", "")), body.appendChild(el("div", "sparc-info-modal__copy", "")), dialog.appendChild(body), modal.appendChild(dialog), document.body.appendChild(modal);
    function closeModal(){
      modal.classList.remove("is-open"), modal.setAttribute("aria-hidden", "true"), document.body.classList.remove("sparc-modal-open")
    }
    return close.addEventListener("click", closeModal), backdrop.addEventListener("click", closeModal), document.addEventListener("keydown", function(e){
      e.key === "Escape" && modal.classList.contains("is-open") && closeModal()
    }), modal
  }
  function openInfoModal(name){
    var content = INFO_CONTENT[name];
    if(content){
      var modal = ensureInfoModal();
      q(".sparc-info-modal__eyebrow", modal).textContent = content.eyebrow, q(".sparc-info-modal__title", modal).textContent = content.title, q(".sparc-info-modal__copy", modal).textContent = content.copy;
      var selection = q(".sparc-info-modal__selection", modal), selectedText = currentSectionSelection(name);
      selection.textContent = selectedText?"CURRENT SELECTION \xB7 " + selectedText: "NO SELECTION YET";
      var image = q(".sparc-info-modal__image", modal), src = currentSectionImage(name);
      src?(image.src = src, image.alt = content.title, image.classList.add("has-image")): (image.removeAttribute("src"), image.classList.remove("has-image")), modal.classList.add("is-open"), modal.setAttribute("aria-hidden", "false"), document.body.classList.add("sparc-modal-open")
    }
  }
  function prepareDriverProductLayout(){
    var section = document.getElementById("ProductSection");
    if(section){
      section.classList.add("sparc-driver-template");
      var main = document.getElementById("MainContent");
      main && main.classList.add("sparc-driver-main-content");
      var meta = q(".product-single__meta", section) || q(".product-single__meta"), optionsColumn = meta?meta.closest(".grid__item"): null;
      meta && meta.classList.add("sparc-driver-product-meta"), optionsColumn && optionsColumn.classList.add("sparc-driver-options-column");
      var photo = q(".product-single__featured-image-wrapper", section) || q(".product-single__photos", section) || q(".product-single__photo", section) || q(".product-single__featured-image", section), heroColumn = photo?photo.closest(".grid__item"): null;
      heroColumn && heroColumn.classList.add("sparc-driver-hero-column");
      var stage = q(".product-single", section) || q(".grid.product-single", section);
      (!stage || !stage.contains(optionsColumn) || !stage.contains(heroColumn)) && optionsColumn && heroColumn && (stage = commonAncestor([optionsColumn, heroColumn])), stage && stage.classList.add("sparc-driver-product-stage"), window.console && console.info && console.info("[SPARC DRIVER V1.14] Layout targets:", {
        stage: stage, heroColumn: heroColumn, optionsColumn: optionsColumn, meta: meta
      })
    }
  }
  function ensureDriverMount(){
    if(!sourceHost || !sourceHost.parentNode)return null;
    var existing = document.getElementById("sparc-driver-configurator-mount");
    if(existing)return existing;
    var mount = el("div", "sparc-driver-configurator-mount");
    mount.id = "sparc-driver-configurator-mount";
    var slot = el("div", "sparc-driver-configurator-panel-slot");
    return slot.id = "sparc-driver-configurator-panel-slot", mount.appendChild(slot), sourceHost.parentNode.insertBefore(mount, sourceHost), mount
  }
  function currentDriverProductTitle(){
    for(var selectors = ["#ProductSection .product-single__title", ".product-single__title", '[itemprop="name"].product-single__title', 'h1[itemprop="name"]'], i = 0; i < selectors.length; i++){
      var node = document.querySelector(selectors[i]);
      if(node){
        var title = clean(node.textContent || "");
        if(title)return title
      }
    }
    var docTitle = clean(document.title || "");
    if(docTitle){
      var parts = docTitle.split(/\s+[–—|-]\s+/);
      if(parts[0])return clean(parts[0])
    }
    return"Steering Wheel"
  }
  function buildPanel(){
    if(sourceHost = commonAncestor(CORE_REF_KEYS.map(function(k){
      return refs[k]
    }).filter(Boolean)), !sourceHost || !sourceHost.parentNode)return!1;
    prepareDriverProductLayout(), ensureDriverMount(), panel = el("section", ""), panel.id = "sparc-driver-configurator";
    var header = el("div", "sparc-build-header"), row = el("div", "sparc-build-header__row"), tw = el("div", "");
    tw.appendChild(el("h2", "sparc-build-title", "Build Your " + currentDriverProductTitle())), tw.appendChild(el("div", "sparc-build-subtitle", "Configure your steering wheel.")), row.appendChild(tw);
    var metrics = el("div", "sparc-build-metrics"), pm = el("div", "");
    pm.appendChild(el("span", "sparc-metric-label", "CONFIGURED PRICE"));
    var pv = el("strong", "sparc-metric-value", "\u2014");
    pv.id = "sparc-config-price", pm.appendChild(pv);
    var lm = el("div", "sparc-lead-metric");
    lm.appendChild(el("span", "sparc-metric-label", "EST. PRODUCTION"));
    var lv = el("strong", "sparc-metric-value", "\u2014");
    lv.id = "sparc-config-lead", lm.appendChild(lv), metrics.appendChild(pm), metrics.appendChild(lm), row.appendChild(metrics), header.appendChild(row);
    var qualifierBar = el("div", "sparc-lead-qualifier-bar", "");
    qualifierBar.id = "sparc-config-lead-qualifier", qualifierBar.hidden = !0, header.appendChild(qualifierBar), panel.appendChild(header);
    var tr = el("nav", "sparc-config-tabs");
    tr.appendChild(makeTab("finish", "FINISH")), tr.appendChild(makeTab("grip", "GRIP")), tr.appendChild(makeTab("leather", "LEATHER")), tr.appendChild(makeTab("mounting", "MOUNTING")), tr.appendChild(makeTab("accessories", "ACCESSORIES")), tr.appendChild(makeTab("summary", "SUMMARY")), panel.appendChild(tr);
    var list = el("div", "sparc-accordion-list");
    accs.finish = accordion("finish", "01", "STEERING WHEEL FINISH"), accs.finish.inner.appendChild(el("p", "sparc-section-help", "Choose the finish for the Driver Series center and spoke assembly. Compare the appearance of each finish and any price difference before making your selection.")), accs.finish.inner.appendChild(cardGrid(refs.finish, 2, !1)), list.appendChild(accs.finish.section), accs.grip = accordion("grip", "02", "GRIP STYLE"), accs.grip.inner.appendChild(el("p", "sparc-section-help", "Choose between the Driver Series D Smooth and D 10/2 grip profiles.")), accs.grip.inner.appendChild(cardGrid(refs.grip, 2, !0)), list.appendChild(accs.grip.section), accs.leather = accordion("leather", "03", "LEATHER & GRIP FINISH"), accs.leather.inner.appendChild(el("p", "sparc-section-help", "Choose Leather Wrap for leather color and stitching, or No Leather for the raw Driver grip and template.")), accs.leather.inner.appendChild(choiceGrid(refs.leatherWrap, {
      Yes: {
        title: "LEATHER WRAP", sub: "Leather color and stitching options appear below."
      }, "None (raw finish)": {
        title: "NO LEATHER", sub: "Raw grip finish. Driver template options appear below."
      }
    })), accs.leatherColorBlock = conditional();
    var lc = q(".sparc-conditional__inner", accs.leatherColorBlock);
    lc.appendChild(el("div", "sparc-subhead", "LEATHER COLOR")), accs.leatherColorChoices = el("div", "sparc-card-grid sparc-card-grid--2 sparc-driver-leather-color-mount"), lc.appendChild(accs.leatherColorChoices), accs.leather.inner.appendChild(accs.leatherColorBlock), accs.stitchBlock = conditional();
    var st = q(".sparc-conditional__inner", accs.stitchBlock);
    st.appendChild(el("div", "sparc-subhead", "STITCHING COLOR")), accs.stitchChoices = el("div", "sparc-stitch-grid sparc-driver-stitch-mount"), st.appendChild(accs.stitchChoices), accs.leather.inner.appendChild(accs.stitchBlock), accs.templateBlock = conditional();
    var tp = q(".sparc-conditional__inner", accs.templateBlock);
    tp.appendChild(el("div", "sparc-subhead", "RAW GRIP TEMPLATE")), accs.templateChoices = el("div", "sparc-choice-grid sparc-driver-template-mount"), tp.appendChild(accs.templateChoices), accs.leather.inner.appendChild(accs.templateBlock), list.appendChild(accs.leather.section), accs.mounting = accordion("mounting", "04", "MOUNTING"), accs.mounting.inner.appendChild(el("p", "sparc-section-help", "Choose the Driver Series column adapter and whether to include a hub sleeve. No Adapter is a valid completed selection."));
    var adapterGroup = el("div", "sparc-mounting-group");
    adapterGroup.appendChild(el("div", "sparc-subhead", "COLUMN ADAPTER")), adapterGroup.appendChild(visualMountingGrid(refs.adapter, "adapter")), accs.mounting.inner.appendChild(adapterGroup), accs.hubSleeveBlock = conditional();
    var sleeveInner = q(".sparc-conditional__inner", accs.hubSleeveBlock), sleeveGroup = el("div", "sparc-mounting-group");
    sleeveGroup.appendChild(el("div", "sparc-subhead", "HUB SLEEVE")), accs.hubSleeveChoices = el("div", "sparc-card-grid sparc-card-grid--2 sparc-driver-hub-sleeve-mount"), sleeveGroup.appendChild(accs.hubSleeveChoices), sleeveInner.appendChild(sleeveGroup), accs.mounting.inner.appendChild(accs.hubSleeveBlock), list.appendChild(accs.mounting.section), accs.accessories = accordion("accessories", "05", "ACCESSORIES"), accs.accessories.inner.appendChild(el("p", "sparc-section-help", "Add optional care accessories to your Driver Series steering wheel package. Accessories are not required."));
    var careGroup = el("div", "sparc-accessory-group sparc-accessory-group--care");
    careGroup.appendChild(el("div", "sparc-subhead", "CARE & MAINTENANCE")), accs.careKitChoices = el("div", "sparc-care-kit-choice-mount"), careGroup.appendChild(accs.careKitChoices), accs.accessories.inner.appendChild(careGroup), list.appendChild(accs.accessories.section), bindLiveAccessoryClicks(), accs.summary = accordion("summary", "\u2713", "CONFIGURATION SUMMARY"), accs.summary.inner.appendChild(el("p", "sparc-summary-intro", "Review every selected option, configured price, and fitment choice before adding your Driver Series steering wheel to the cart."));
    var sum = el("div", "sparc-summary");
    [["finish", "Steering Wheel Finish"], ["grip", "Grip Style"], ["leatherWrap", "Leather Wrap"], ["leatherColor", "Leather Color"], ["stitching", "Stitching"], ["leatherTemplate", "Raw Grip Template"], ["adapter", "Adapter"], ["hubSleeve", "Hub Sleeve"], ["careKit", "Steering Wheel Care Kit"]].forEach(function(pair){
      var sr = el("div", "sparc-summary-row");
      sr.appendChild(el("div", "sparc-summary__label", pair[1])), sr.appendChild(el("span", "sparc-summary__leader", ""));
      var value = el("div", "sparc-summary__value", "\u2014");
      value.dataset.summaryKey = pair[0], sr.appendChild(value), sum.appendChild(sr)
    }), accs.summary.inner.appendChild(sum), list.appendChild(accs.summary.section), panel.appendChild(list);
    var slot = document.getElementById("sparc-driver-configurator-panel-slot"), mount = document.getElementById("sparc-driver-configurator-mount");
    return slot?slot.appendChild(panel): mount?mount.insertBefore(panel, mount.firstChild): sourceHost.parentNode.insertBefore(panel, sourceHost), Object.keys(refs).forEach(function(k){
      refs[k] && !panel.contains(refs[k]) && refs[k].classList.add("sparc-source-hidden")
    }), ensureDriverConditionalUI(), ensureAccessoryUI(), hideLegacyDecorations(), openSection("finish"), setTimeout(debugImageData, 250), !0
  }
  function refreshVisualCardImages(root, section){
    if(!(!root || !section)){
      var latest = choices(root);
      qa(".sparc-option-card[data-value]", section).forEach(function(card){
        var value = card.dataset.value, choice = latest.find(function(c){
          return String(c.value) === String(value)
        });
        if(choice){
          var detail = matchingOptionDetail(root.id, value), imageUrl = selectorImageForOption(root, value, choice.image), imageWrap = q(".sparc-option-card__image", card);
          if(imageWrap){
            var existingImg = q("img", imageWrap), placeholder = q(".sparc-option-card__placeholder", imageWrap);
            imageUrl?(existingImg || (existingImg = document.createElement("img"), imageWrap.innerHTML = "", imageWrap.appendChild(existingImg)), existingImg.alt = detail && detail.imageAltText?detail.imageAltText: friendly(value), existingImg.src !== imageUrl && (existingImg.src = imageUrl)): (existingImg && (imageWrap.innerHTML = "", placeholder = null), placeholder || (placeholder = el("div", "sparc-option-card__placeholder", "Add option image in Hulk Admin"), imageWrap.appendChild(placeholder)))
          }
        }
      })
    }
  }
  function refreshMountingCardImages(root, section){
    if(!(!root || !section)){
      var latest = choices(root);
      qa(".sparc-mounting-card[data-source-id][data-value]", section).forEach(function(card){
        if(card.dataset.sourceId !== root.id)return;
        var value = card.dataset.value, choice = latest.find(function(c){
          return String(c.value) === String(value)
        });
        if(!choice)return;
        var detail = matchingOptionDetail(root.id, value), imageUrl = selectorImageForOption(root, value, choice.image), visual = q(".sparc-mounting-card__visual", card);
        if(!visual)return;
        if(imageUrl){
          var img = q("img", visual);
          if(!img){
            visual.innerHTML = "", img = document.createElement("img"), visual.appendChild(img)
          }
          img.src = imageUrl, img.alt = detail && detail.imageAltText?detail.imageAltText: friendly(value), img.style.width = "100%", img.style.height = "100%", img.style.objectFit = "contain", img.style.objectPosition = "center", img.style.display = "block"
        }
        else if(!q(".sparc-option-card__placeholder", visual))visual.innerHTML = "", visual.appendChild(el("div", "sparc-option-card__placeholder", "Add option image in Hulk Admin"))
      })
    }
  }
  function syncChoiceClasses(root, section){
    if(!(!root || !section)){
      var value = current(root);
      qa("[data-source-id][data-value]", section).forEach(function(node){
        node.dataset.sourceId === root.id && node.classList.toggle("is-selected", String(node.dataset.value) === String(value))
      })
    }
  }
  function setConditional(block, show){
    block && block.classList.toggle("is-visible", !!show)
  }
  function moveChildren(from, to){
    for(; from && from.firstChild; )to.appendChild(from.firstChild)
  }
  function hideLegacyAccessoryLabels(){
    if(panel){
      var form = panel.closest("form") || document.querySelector("form[action*='/cart/add']") || document, matches = qa("*", form).filter(function(node){
        return panel.contains(node) || node.classList.contains("sparc-source-hidden") || node.classList.contains("sparc-source-decoration-hidden") || containsCoreRef(node)?!1: clean(node.textContent).toLowerCase() === "steering wheel care kit"
      });
      matches.sort(function(a, b){
        if(a.children.length !== b.children.length)return a.children.length - b.children.length;
        var ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
        return ar.width * ar.height - br.width * br.height
      }), matches.length && matches[0].classList.add("sparc-source-decoration-hidden")
    }
  }
  function safelyHideAccessorySource(root){
    root && panel && root !== sourceHost && (root === panel || root.contains(panel) || containsCoreRef(root) || root.classList.add("sparc-source-hidden"))
  }
  function accessoryKeyForSourceId(sourceId){
    return sourceId === IDS.careKit?"careKit": ""
  }
  function currentAccessoryRoot(key){
    return key === "careKit"?(refs[key] = resolveAccessoryRef(key), refs[key] || null): (refreshRefs(), refs[key] || null)
  }
  function bindLiveAccessoryClicks(){
    !accs.accessories || !accs.accessories.section || accs.accessories.section._sparcLiveAccessoryBound || (accs.accessories.section._sparcLiveAccessoryBound = !0, accs.accessories.section.addEventListener("click", function(e){
      if(!e.target.closest(".sparc-option-info")){
        var card = e.target.closest(".sparc-option-card[data-source-id]");
        if(!(!card || !accs.accessories.section.contains(card))){
          var key = card.dataset.accessoryKey || accessoryKeyForSourceId(card.dataset.sourceId || "");
          if(key === "careKit"){
            var root = currentAccessoryRoot("careKit");
            if(root){
              e.preventDefault(), e.stopImmediatePropagation(), e.__sparcCareHandled = !0;
              var nextValue = valueEquals(current(root), "Yes")?"No": "Yes";
              choose(root, nextValue), requestAnimationFrame(function(){
                var liveCare = currentAccessoryRoot("careKit");
                liveCare && syncChoiceClasses(liveCare, accs.accessories.section)
              })
            }
          }
        }
      }
    }, !0))
  }
  function ensureAccessoryUI(){
    var live = resolveAccessoryRef("careKit");
    if(live && (refs.careKit = live, panel && !panel.contains(live) && safelyHideAccessorySource(live)), accs.careKitChoices){
      var careId = refs.careKit && refs.careKit.id || "", renderedCareId = accs.careKitChoices.dataset.sourceId || "";
      refs.careKit && (renderedCareId !== careId || !accs.careKitChoices.children.length) && (accs.careKitChoices.innerHTML = "", accs.careKitChoices.dataset.sourceId = careId, moveChildren(optionalAccessoryToggleCard(refs.careKit, "Yes", "No", "STEERING WHEEL CARE KIT", "Add the SPARC steering wheel care kit to your order. Select the card again to remove it."), accs.careKitChoices))
    }
    hideLegacyAccessoryLabels()
  }
  function replaceMountChildren(mount, content, sourceId){
    if(mount){
      var rendered = mount.dataset.sourceId || "";
      sourceId && rendered === sourceId && mount.children.length || (mount.innerHTML = "", mount.dataset.sourceId = sourceId || "", content && moveChildren(content, mount))
    }
  }
  function ensureDriverConditionalUI(){
    refreshRefs(), refs.leatherColor && (panel && !panel.contains(refs.leatherColor) && refs.leatherColor.classList.add("sparc-source-hidden"), replaceMountChildren(accs.leatherColorChoices, cardGrid(refs.leatherColor, 2, !1), refs.leatherColor.id)), refs.stitching && (panel && !panel.contains(refs.stitching) && refs.stitching.classList.add("sparc-source-hidden"), replaceMountChildren(accs.stitchChoices, stitchGrid(refs.stitching), refs.stitching.id)), refs.leatherTemplate && (panel && !panel.contains(refs.leatherTemplate) && refs.leatherTemplate.classList.add("sparc-source-hidden"), replaceMountChildren(accs.templateChoices, choiceGrid(refs.leatherTemplate, {
      None: {
        title: "NONE", sub: "No leather-wrapping template."
      }, "D Smooth Template": {
        title: "D SMOOTH TEMPLATE", sub: "Template for the Driver D Smooth raw grip."
      }, "D 10/2 Template": {
        title: "D 10/2 TEMPLATE", sub: "Template for the Driver D 10/2 raw grip."
      }
    }), refs.leatherTemplate.id)), refs.hubSleeve && (panel && !panel.contains(refs.hubSleeve) && refs.hubSleeve.classList.add("sparc-source-hidden"), replaceMountChildren(accs.hubSleeveChoices, visualMountingGrid(refs.hubSleeve, "sleeve"), refs.hubSleeve.id))
  }
  function hubSleeveApplies(){
    return!!(refs.hubSleeve && sourceVisible(refs.hubSleeve))
  }
  function hubSleeveIsRequired(){
    return hubSleeveApplies()
  }
  function syncMirror(field, root){
    field && field._mirror && (field._mirror.value = current(root))
  }
  function sync(){
    if(syncPending = !1, !!panel){
      refreshRefs(), ensureDriverConditionalUI(), ensureAccessoryUI();
      var s = getState(), leatherColorVisible = !!(refs.leatherColor && sourceVisible(refs.leatherColor)), stitchingVisible = !!(refs.stitching && sourceVisible(refs.stitching)), templateVisible = !!(refs.leatherTemplate && sourceVisible(refs.leatherTemplate)), hubSleeveVisible = !!(refs.hubSleeve && sourceVisible(refs.hubSleeve));
      syncChoiceClasses(refs.finish, accs.finish.section), syncChoiceClasses(refs.grip, accs.grip.section), syncChoiceClasses(refs.leatherWrap, accs.leather.section), syncChoiceClasses(refs.leatherColor, accs.leather.section), syncChoiceClasses(refs.stitching, accs.leather.section), syncChoiceClasses(refs.leatherTemplate, accs.leather.section), syncChoiceClasses(refs.adapter, accs.mounting.section), syncChoiceClasses(refs.hubSleeve, accs.mounting.section), syncChoiceClasses(refs.careKit, accs.accessories.section), refreshVisualCardImages(refs.finish, accs.finish.section), refreshVisualCardImages(refs.grip, accs.grip.section), refs.leatherColor && refreshVisualCardImages(refs.leatherColor, accs.leather.section), refs.careKit && refreshVisualCardImages(refs.careKit, accs.accessories.section), refreshVisualCardImages(refs.adapter, accs.mounting.section), refs.hubSleeve && refreshVisualCardImages(refs.hubSleeve, accs.mounting.section);
      setConditional(accs.leatherColorBlock, leatherColorVisible), setConditional(accs.stitchBlock, stitchingVisible), setConditional(accs.templateBlock, templateVisible), setConditional(accs.hubSleeveBlock, hubSleeveVisible), q("#sparc-config-price", panel).textContent = configuredPrice(), q("#sparc-config-lead", panel).textContent = leadTime(s);
      var leadQualifierNode = q("#sparc-config-lead-qualifier", panel);
      if(leadQualifierNode){
        var qualifier = leadQualifier(s);
        leadQualifierNode.textContent = qualifier, leadQualifierNode.hidden = !qualifier, leadQualifierNode.classList.toggle("is-visible", !!qualifier)
      }
      leadDebugEnabled() && setTimeout(renderLeadDebug, 0), q(".sparc-accordion__summary", accs.finish.section).textContent = friendly(s.finish), q(".sparc-accordion__summary", accs.grip.section).textContent = friendly(s.grip);
      var leatherParts = [];
      s.leatherWrap && leatherParts.push(friendly(s.leatherWrap)), leatherColorVisible && (s.leatherColor?leatherParts.push(friendly(s.leatherColor)): leatherParts.push("Leather color required")), stitchingVisible && (s.stitching?leatherParts.push(friendly(s.stitching) + " Stitch"): leatherParts.push("Stitching required")), templateVisible && (s.leatherTemplate?leatherParts.push(friendly(s.leatherTemplate)): leatherParts.push("Template required")), q(".sparc-accordion__summary", accs.leather.section).textContent = leatherParts.length?leatherParts.join(" \xB7 "): "Not selected";
      var ms = s.adapter?friendly(s.adapter): "Not selected";
      hubSleeveVisible && s.hubSleeve && (ms += " \xB7 Sleeve " + friendly(s.hubSleeve)), q(".sparc-accordion__summary", accs.mounting.section).textContent = ms, q(".sparc-accordion__summary", accs.accessories.section).textContent = valueEquals(s.careKit, "Yes")?"Care Kit": "None selected", qa("[data-summary-key]", accs.summary.section).forEach(function(n){
        var key = n.dataset.summaryKey, v = s[key];
        key === "leatherColor" && !leatherColorVisible && (v = ""), key === "stitching" && !stitchingVisible && (v = ""), key === "leatherTemplate" && !templateVisible && (v = ""), key === "hubSleeve" && !hubSleeveVisible && (v = ""), key === "careKit" && (v = valueEquals(v, "Yes")?"Included": ""), n.textContent = v?friendly(v): "\u2014"
      }), sparcValidationAttempted && applyValidationState(), scheduleResize()
    }
  }
  function queueSync(){
    syncPending || (syncPending = !0, requestAnimationFrame(sync))
  }
  function delayedSync(){
    queueSync(), clearTimeout(syncTimer), syncTimer = setTimeout(function(){
      if(syncTimer = null, queueSync(), panel){
        var priceNode = q("#sparc-config-price", panel);
        priceNode && (priceNode.textContent = configuredPrice())
      }
    }, 140)
  }
  function alignDriverProductStage(){
    var stage = q(".sparc-driver-product-stage");
    if(stage){
      if(window.innerWidth <= 860){
        stage.style.width = "", stage.style.maxWidth = "", stage.style.marginLeft = "", stage.style.marginRight = "";
        return
      }
      var parent = stage.parentElement;
      if(parent){
        var viewportWidth = document.documentElement.clientWidth || window.innerWidth, stageWidth = Math.min(1450, Math.max(0, viewportWidth - 32)), desiredLeft = Math.max(16, (viewportWidth - stageWidth)/2), parentRect = parent.getBoundingClientRect();
        stage.style.width = Math.round(stageWidth) + "px", stage.style.maxWidth = Math.round(stageWidth) + "px", stage.style.marginLeft = Math.round(desiredLeft - parentRect.left) + "px", stage.style.marginRight = "0"
      }
    }
  }
  function applyStageHeight(){
    alignDriverProductStage();
    var stage = q(".sparc-driver-product-stage"), options = q(".sparc-driver-options-column"), hero = q(".sparc-driver-hero-column");
    if(!stage)return;
    if(window.innerWidth <= 860){
      stage.style.minHeight = "", stage.style.height = "";
      return
    }
    var required = 800;
    [hero, options].forEach(function(node){
      if(node && node.offsetWidth > 0 && node.offsetHeight > 0){
        var bottom = node.offsetTop + node.offsetHeight + 70;
        required = Math.max(required, bottom)
      }
    });
    var nextHeight = Math.ceil(required);
    if(parseFloat(stage.style.minHeight || "0") !== nextHeight)stage.style.minHeight = nextHeight + "px"
  }
  function notifySharedStickyHero(){
    /*
     * Intentionally no synthetic resize event here.
     * The shared sticky controller already watches the Driver stage and
     * configurator with ResizeObserver. Dispatching a fake window resize
     * forces its real responsive resize path, which temporarily returns
     * the hero to normal flow and causes the visible jump.
     */
  }
  function scheduleResize(duration){
    if(typeof duration !== "number")duration = 520;
    if(window.innerWidth <= 860){
      resizeTrackUntil = 0;
      resizeFrame && cancelAnimationFrame(resizeFrame), resizeFrame = 0;
      applyStageHeight();
      notifySharedStickyHero();
      return
    }
    var until = performance.now() + Math.max(40, duration);
    resizeTrackUntil = Math.max(resizeTrackUntil || 0, until);
    if(resizeFrame)return;
    function track(now){
      applyStageHeight();
      if(now < resizeTrackUntil){
        resizeFrame = requestAnimationFrame(track)
      }
      else{
        resizeFrame = 0, resizeTrackUntil = 0;
        applyStageHeight();
        requestAnimationFrame(function(){
          notifySharedStickyHero()
        })
      }
    }
    resizeFrame = requestAnimationFrame(track)
  }
  function activateTrueDriverWidth(){
    if(panel){
      document.body.classList.add("sparc-driver-v13-active");
      var main = document.getElementById("MainContent");
      main && main.classList.add("sparc-driver-main-content"), !(!main || !main.parentElement) && Array.prototype.forEach.call(main.parentElement.children, function(child){
        /*
         * Hide the old Supply sidebar only. Never hide the shared
         * option-detail modal if it is already present beside MainContent.
         */
        child !== main &&
        child.id !== "sparc-info-modal" &&
        child.classList.add("sparc-driver-v13-sidebar-hidden")
      });

      var infoModal = document.getElementById("sparc-info-modal");
      infoModal && infoModal.classList.remove("sparc-driver-v13-sidebar-hidden")
    }
  }
  function hideSmallestExactText(root, regex, className){
    if(!(!root || !panel)){
      var panelTop = panel.getBoundingClientRect().top, matches = qa("*", root).filter(function(node){
        if(panel.contains(node) || node.classList.contains("sparc-source-hidden"))return!1;
        var text = clean(node.textContent);
        if(!regex.test(text))return!1;
        var rect = node.getBoundingClientRect();
        return!(rect.top >= panelTop)
      });
      matches.sort(function(a, b){
        var aText = clean(a.textContent).length, bText = clean(b.textContent).length;
        return aText !== bText?aText - bText: a.children.length - b.children.length
      }), matches.length && matches[0].classList.add(className)
    }
  }
  function hideLegacyTopPriceAndLeadV13(){
    if(panel){
      var meta = panel.closest(".sparc-driver-product-meta") || panel.closest(".product-single__meta") || panel.parentElement;
      meta && (hideSmallestExactText(meta, /^\$[\d,]+(?:\.\d{2})?$/, "sparc-v13-old-price"), hideSmallestExactText(meta, /^Up to\s+\d+\s+week(?:s)?\s+lead\s+time$/i, "sparc-v13-old-lead"))
    }
  }
  function moveQuantityBelowConfigurator(){
    if(panel){
      var mount = document.getElementById("sparc-driver-configurator-mount"), slot = document.getElementById("sparc-driver-configurator-panel-slot"), optionsColumn = q(".sparc-driver-options-column") || panel.closest(".grid__item"), form = mount && mount.closest("form") || panel.closest("form") || optionsColumn && q("form", optionsColumn) || q("form.product-form"), realInput = form && q('input[name="quantity"]', form) || optionsColumn && q('input[name="quantity"]', optionsColumn) || q("#Quantity", document) || q('input[name="quantity"]', document);
      if(realInput){
        qa(".product-single__quantity", document).forEach(function(block){
          (block.contains(realInput) || q('input[name="quantity"]', block)) && block.classList.add("sparc-real-quantity-hidden")
        });
        for(var p = realInput.parentElement, i = 0; i < 6 && p && p !== document.body && !panel.contains(p); i++, p = p.parentElement){
          var rect = p.getBoundingClientRect(), text = clean(p.textContent).toLowerCase(), qtyInputs = qa('input[name="quantity"], #Quantity', p), compact = rect.width > 0 && rect.height > 0 && rect.height < 130 && rect.width < 900, looksLikeQuantity = text.indexOf("quantity") !== - 1 && qtyInputs.length === 1;
          if(compact && looksLikeQuantity){
            p.classList.add("sparc-real-quantity-hidden");
            break
          }
        }
        var host = mount || slot && slot.parentElement || panel.parentElement;
        if(host){
          var mirror = q(".sparc-quantity-mirror", host);
          if(!mirror){
            mirror = el("div", "sparc-quantity-mirror");
            var label = el("label", "sparc-quantity-mirror__label", "QUANTITY"), input = document.createElement("input");
            input.type = "number", input.min = realInput.min || "1", input.step = realInput.step || "1", input.value = realInput.value || "1", input.className = "sparc-quantity-mirror__input", mirror.appendChild(label), mirror.appendChild(input), input.addEventListener("input", function(){
              realInput.value = input.value, realInput.dispatchEvent(new Event("input", {
                bubbles: !0
              })), realInput.dispatchEvent(new Event("change", {
                bubbles: !0
              }))
            }), input.addEventListener("change", function(){
              realInput.value = input.value, realInput.dispatchEvent(new Event("change", {
                bubbles: !0
              }))
            }), realInput.addEventListener("change", function(){
              input.value !== realInput.value && (input.value = realInput.value)
            })
          }
          mount && slot?(mirror.parentElement !== mount || slot.nextSibling !== mirror) && mount.insertBefore(mirror, slot.nextSibling): (mirror.parentElement !== host && host.appendChild(mirror), panel.nextSibling !== mirror && host.insertBefore(mirror, panel.nextSibling));
          var mirrorInput = q(".sparc-quantity-mirror__input", mirror);
          mirrorInput && mirrorInput.value !== realInput.value && (mirrorInput.value = realInput.value || "1")
        }
      }
    }
  }
  function hideOldProductPriceAndLeadTime(){
    if(panel){
      var meta = panel.closest(".sparc-driver-product-meta") || panel.parentElement;
      if(meta){
        var panelTop = panel.getBoundingClientRect().top;
        qa("*", meta).forEach(function(node){
          if(!panel.contains(node) && !node.classList.contains("sparc-source-hidden")){
            var text = clean(node.textContent);
            if(text){
              var rect = node.getBoundingClientRect();
              rect.top >= panelTop || (node.children.length === 0 && /^\$[\d,]+(?:\.\d{2})?$/.test(text) && node.classList.add("sparc-old-product-price-hidden"), node.children.length === 0 && /^(?:up to\s+)?\d+\s*(?:-|–|to)?\s*\d*\s*week(?:s)?(?:\s+lead\s+time)?$/i.test(text) && node.classList.add("sparc-old-lead-time-hidden"))
            }
          }
        }), qa("p,div,span", meta).forEach(function(node){
          if(!panel.contains(node) && !(node.children.length > 1)){
            var text = clean(node.textContent), rect = node.getBoundingClientRect();
            rect.top >= panelTop || /^Up to \d+\s*week(?:s)? lead time$/i.test(text) && node.classList.add("sparc-old-lead-time-hidden")
          }
        })
      }
    }
  }
  function applyV11Polish(){
    activateTrueDriverWidth(), alignDriverProductStage(), moveQuantityBelowConfigurator(), hideOldProductPriceAndLeadTime(), hideLegacyTopPriceAndLeadV13(), scheduleResize()
  }
  var sparcValidationAttempted = !1;
  function hasUploadedCustomFile(){
    if(!accs.customLaserBlock)return!1;
    if(accs.customLaserBlock._sparcProxyFile)return syncProxyFileToHulk();
    var source = findCustomLaserFileSource(), input = accs.customLaserBlock._sparcFileInput || source && source.input;
    return!!(input && input.files && input.files.length > 0)
  }
  function sectionValidity(s){
    var leatherOK = !!s.leatherWrap, mountingOK = !!s.adapter;
    refs.leatherColor && sourceVisible(refs.leatherColor) && (leatherOK = leatherOK && !!s.leatherColor), refs.stitching && sourceVisible(refs.stitching) && (leatherOK = leatherOK && !!s.stitching), refs.leatherTemplate && sourceVisible(refs.leatherTemplate) && (leatherOK = leatherOK && !!s.leatherTemplate), refs.hubSleeve && sourceVisible(refs.hubSleeve) && (mountingOK = mountingOK && !!s.hubSleeve);
    return{
      finish: !!s.finish, grip: !!s.grip, leather: leatherOK, mounting: mountingOK, accessories: !0
    }
  }
  function applyValidationState(){
    if(!panel)return!0;
    var s = getState(), validity = sectionValidity(s), firstInvalid = null, anyInvalid = !1;
    return["finish", "grip", "leather", "mounting", "accessories"].forEach(function(name){
      var invalid = !validity[name];
      accs[name] && accs[name].section && accs[name].section.classList.toggle("sparc-invalid", invalid), invalid && !firstInvalid && (firstInvalid = name), invalid && (anyInvalid = !0)
    }), panel.classList.toggle("sparc-has-invalid", anyInvalid), !anyInvalid
  }
  function showValidationWarnings(){
    sparcValidationAttempted = !0, panel.classList.add("sparc-validation-attempted");
    var valid = applyValidationState();
    if(!valid){
      var s = getState(), validity = sectionValidity(s), firstInvalid = ["finish", "grip", "leather", "mounting", "accessories"].find(function(name){
        return!validity[name]
      });
      firstInvalid && (openSection(firstInvalid), setTimeout(function(){
        accs[firstInvalid] && accs[firstInvalid].section && accs[firstInvalid].section.scrollIntoView({
          behavior: "smooth", block: "center"
        })
      }, 80))
    }
    return valid
  }
  function isAddToCartControl(node){
    if(!node)return!1;
    var control = node.closest('button,input[type="submit"],a');
    if(!control)return!1;
    var text = clean((control.textContent || "") + " " + (control.value || "") + " " + (control.getAttribute("aria-label") || "")).toLowerCase();
    return/add\s+to\s+cart/.test(text)
  }
  function installRequiredValidation(){
    if(panel){
      var list = q(".sparc-accordion-list", panel);
      if(list && !q(".sparc-validation-message", panel)){
        var msg = el("div", "sparc-validation-message", "Please complete the required configuration options highlighted below before adding this steering wheel to your cart.");
        list.insertBefore(msg, list.firstChild)
      }
      document.addEventListener("click", function(e){
        if(isAddToCartControl(e.target)){
          var control = e.target.closest('button,input[type="submit"],a'), productArea = q(".sparc-driver-options-column", document) || q("#ProductSection", document);
          productArea && !productArea.contains(control) || showValidationWarnings() || (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation())
        }
      }, !0);
      var form = document.getElementById("sparc-driver-configurator-mount") && document.getElementById("sparc-driver-configurator-mount").closest("form");
      form && form.addEventListener("submit", function(e){
        showValidationWarnings() || (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation())
      }, !0)
    }
  }
  function accessoryDebugEnabled(){
    try{
      return new URLSearchParams(window.location.search).get("sparc_accessory_debug") === "1"
    }
    catch(e){
      return!1
    }
  }
  function logAccessoryDebug(label){
    if(accessoryDebugEnabled()){
      var care = resolveAccessoryRef("careKit");
      console.info("[SPARC DRIVER V1 ACCESSORIES] " + label, {
        careValue: current(care), careRoot: care
      })
    }
  }
  function ensureRuntimeBreadcrumbStyle(){
    if(!document.getElementById("sparc-driver-runtime-breadcrumb-style")){
      var style = document.createElement("style");
      style.id = "sparc-driver-runtime-breadcrumb-style", style.textContent = "#sparc-driver-runtime-breadcrumb-wrap{display:block!important;box-sizing:border-box!important;width:100%!important;height:auto!important;min-height:28px!important;margin:0 0 18px!important;padding:0!important;overflow:visible!important;}#sparc-driver-runtime-breadcrumb{display:flex!important;align-items:center!important;gap:7px!important;height:auto!important;min-height:22px!important;margin:0!important;padding:3px 0 4px!important;line-height:17px!important;overflow:visible!important;font:inherit!important;font-size:11px!important;white-space:nowrap!important;}#sparc-driver-runtime-breadcrumb a,#sparc-driver-runtime-breadcrumb span{display:inline-block!important;position:static!important;height:auto!important;min-height:17px!important;margin:0!important;padding:1px 0!important;line-height:17px!important;overflow:visible!important;vertical-align:middle!important;text-decoration:none;}#sparc-driver-runtime-breadcrumb .sparc-driver-runtime-breadcrumb__sep{opacity:.7;}", document.head.appendChild(style)
    }
  }
  function findLegacyDriverBreadcrumbs(productTitle){
    var titleNorm = clean(productTitle).toLowerCase();
    return qa("*", document).filter(function(node){
      if(!node || node === document.body || node === document.documentElement)return!1;
      var rect = node.getBoundingClientRect(), text = clean(node.textContent).toLowerCase();
      if(rect.top < 50 || rect.top > 280 || rect.left < 40 || rect.left > 650 || rect.width <= 0 || rect.width > 760 || rect.height <= 0 || rect.height > 90)return!1;
      var hasHome = text.indexOf("home") !== - 1, hasSeries = text.indexOf("driver series") !== - 1, hasTitle = titleNorm && text.indexOf(titleNorm) !== - 1;
      return hasHome && hasSeries || hasSeries && hasTitle
    })
  }
  function normalizeRenderedBreadcrumbText(value){
    return String(value || "").replace(/[›>»\/|·•]/g, " ").replace(/[^a-zA-Z0-9]+/g, " ").replace(/\s+/g, " ").trim().toLowerCase()
  }
  function hideRenderedLegacyBreadcrumb(runtimeWrap, productTitle){
    if(runtimeWrap){
      var runtimeRect = runtimeWrap.getBoundingClientRect(), target = normalizeRenderedBreadcrumbText("Home Driver Series " + productTitle);
      if(target){
        var exact = [], fallback = [];
        qa("*", document.body).forEach(function(node){
          if(!(node === runtimeWrap || runtimeWrap.contains(node) || node.contains(runtimeWrap))){
            var rect = node.getBoundingClientRect();
            if(!(rect.width <= 0 || rect.height <= 0 || rect.left < 0 || rect.left > 700 || rect.top < 35 || rect.top >= runtimeRect.top - 2 || rect.width > 850 || rect.height > 100)){
              var visible = "";
              try{
                visible = node.innerText || ""
              }
              catch(e){
                visible = node.textContent || ""
              }
              var norm = normalizeRenderedBreadcrumbText(visible);
              if(norm){
                var record = {
                  node: node, rect: rect, norm: norm, area: rect.width * rect.height
                };
                if(norm === target){
                  exact.push(record);
                  return
                }
                norm.indexOf("home") !== - 1 && norm.indexOf("driver series") !== - 1 && norm.indexOf(normalizeRenderedBreadcrumbText(productTitle)) !== - 1 && norm.length <= target.length + 24 && fallback.push(record)
              }
            }
          }
        });
        var matches = exact.length?exact: fallback;
        if(matches.length){
          matches.sort(function(a, b){
            return a.area !== b.area?a.area - b.area: b.rect.top - a.rect.top
          });
          var legacy = matches[0].node;
          legacy.style.setProperty("display", "none", "important"), legacy.setAttribute("data-sparc-legacy-breadcrumb-hidden", "true")
        }
      }
    }
  }
  function hideLegacyBreadcrumbByLinks(runtimeWrap, productTitle){
    if(!runtimeWrap)return;
    var runtimeRect = runtimeWrap.getBoundingClientRect(), titleNorm = clean(productTitle).toLowerCase();
    function visible(node){
      if(!node)return!1;
      var r = node.getBoundingClientRect();
      return r.width > 0 && r.height > 0
    }
    function isRuntime(node){
      return node === runtimeWrap || runtimeWrap.contains(node) || node.contains(runtimeWrap)
    }
    qa("a", document).forEach(function(home){
      if(!isRuntime(home) && clean(home.textContent).toLowerCase() === "home" && visible(home)){
        var hr = home.getBoundingClientRect();
        if(!(hr.left > 700 || hr.top < 30 || hr.top > runtimeRect.bottom + 25)){
          for(var p = home.parentElement, line = null, i = 0; i < 8 && p && p !== document.body && !isRuntime(p); i++, p = p.parentElement){
            var links = qa("a", p), hasHome = links.some(function(a){
              return clean(a.textContent).toLowerCase() === "home"
            }), hasSeries = links.some(function(a){
              return clean(a.textContent).toLowerCase().indexOf("driver series") !== - 1
            });
            if(hasHome && hasSeries){
              line = p;
              break
            }
          }
          line && !isRuntime(line)?(line.style.setProperty("display", "none", "important"), line.setAttribute("data-sparc-legacy-breadcrumb-hidden", "home-series")): home.style.setProperty("display", "none", "important")
        }
      }
    }), qa("a", document).forEach(function(series){
      if(!isRuntime(series)){
        var st = clean(series.textContent).toLowerCase();
        if(st.indexOf("driver series") !== - 1 && visible(series)){
          var sr = series.getBoundingClientRect();
          if(!(sr.left > 700 || sr.top < 30 || sr.top > runtimeRect.bottom + 35)){
            for(var p = series.parentElement, fragment = null, i = 0; i < 6 && p && p !== document.body && !isRuntime(p); i++, p = p.parentElement){
              var text = clean(p.textContent).toLowerCase(), rect = p.getBoundingClientRect(), hasProduct = titleNorm && text.indexOf(titleNorm) !== - 1, hasHome = text.indexOf("home") !== - 1;
              if(hasProduct && !hasHome && rect.width > 0 && rect.width < 700 && rect.height > 0 && rect.height < 80){
                fragment = p;
                break
              }
            }
            fragment && !isRuntime(fragment) && (fragment.style.setProperty("display", "none", "important"), fragment.setAttribute("data-sparc-legacy-breadcrumb-hidden", "series-product"))
          }
        }
      }
    })
  }
  function cleanupDriverBreadcrumbDuplicates(runtimeWrap, productTitle){
    if(!runtimeWrap)return;
    var titleNorm = normalizeRenderedBreadcrumbText(productTitle), target = normalizeRenderedBreadcrumbText("Home Driver Series " + productTitle);
    function isRuntime(node){
      return node === runtimeWrap || runtimeWrap.contains(node) || node.contains(runtimeWrap)
    }
    qa("*", document.body).forEach(function(node){
      if(!(!node || isRuntime(node))){
        var rect = node.getBoundingClientRect();
        if(!(rect.width <= 0 || rect.height <= 0 || rect.top < 30 || rect.top > 320 || rect.left < 0 || rect.left > 720 || rect.width > 900 || rect.height > 100)){
          var visible = "";
          try{
            visible = node.innerText || ""
          }
          catch(e){
            visible = node.textContent || ""
          }
          var norm = normalizeRenderedBreadcrumbText(visible);
          if(norm){
            var hasHome = norm.indexOf("home") !== - 1, hasSeries = norm.indexOf("driver series") !== - 1, hasTitle = !!titleNorm && norm.indexOf(titleNorm) !== - 1, exact = norm === target, compactMatch = hasHome && hasSeries && hasTitle && norm.length <= target.length + 30;
            (exact || compactMatch) && (node.style.setProperty("display", "none", "important"), node.setAttribute("data-sparc-driver-legacy-breadcrumb-hidden", "true"))
          }
        }
      }
    }), qa("a", document).forEach(function(home){
      if(!isRuntime(home) && clean(home.textContent).toLowerCase() === "home"){
        var hr = home.getBoundingClientRect();
        if(!(hr.width <= 0 || hr.height <= 0 || hr.top < 30 || hr.top > 320 || hr.left > 720))for(var p = home.parentElement, i = 0; i < 8 && p && p !== document.body && !isRuntime(p); i++, p = p.parentElement){
          var rect = p.getBoundingClientRect();
          if(!(rect.width <= 0 || rect.height <= 0 || rect.width > 900 || rect.height > 100)){
            var text = normalizeRenderedBreadcrumbText(p.innerText || p.textContent);
            if(text.indexOf("home") !== - 1 && text.indexOf("driver series") !== - 1 && (!titleNorm || text.indexOf(titleNorm) !== - 1)){
              p.style.setProperty("display", "none", "important"), p.setAttribute("data-sparc-driver-legacy-breadcrumb-hidden", "link-fallback");
              break
            }
          }
        }
      }
    })
  }
  function replaceDriverBreadcrumb(){
    if(ensureRuntimeBreadcrumbStyle(), document.getElementById("sparc-driver-runtime-breadcrumb-wrap"))return;
    var productTitle = currentDriverProductTitle && typeof currentDriverProductTitle == "function"?currentDriverProductTitle(): "";
    if(!productTitle){
      var title = q(".product-single__title") || q("#ProductSection .product-single__title");
      productTitle = title?clean(title.textContent): ""
    }
    var homeLinks = qa("a", document).filter(function(a){
      return clean(a.textContent).toLowerCase() === "home"
    }), homeLink = null, seriesLink = null, originalBreadcrumb = null;
    homeLinks.some(function(home){
      if(home.closest("#sparc-driver-runtime-breadcrumb-wrap"))return!1;
      for(var p = home.parentElement, i = 0; i < 6 && p && p !== document.body; i++, p = p.parentElement){
        var text = clean(p.textContent), rect = p.getBoundingClientRect(), hasHome = text.toLowerCase().indexOf("home") === 0, hasSeries = text.toLowerCase().indexOf("driver series") !== - 1, compact = rect.top >= 40 && rect.top < 260 && rect.left < 700 && rect.width > 0 && rect.width < 800 && rect.height > 0 && rect.height < 90 && text.length < 200;
        if(hasHome && hasSeries && compact)return homeLink = home, originalBreadcrumb = p, seriesLink = qa("a", p).find(function(a){
          return clean(a.textContent).toLowerCase().indexOf("driver series") !== - 1
        }) || null, !0
      }
      return!1
    });
    var productSection = document.getElementById("ProductSection") || q(".product-single") || q("main");
    if(!productSection)return;
    for(var insertionTarget = productSection, parent = productSection.parentElement; parent && parent !== document.body && parent.children.length === 1 && parent.getBoundingClientRect().width < 1200; )insertionTarget = parent, parent = parent.parentElement;
    var wrap = el("div", "sparc-driver-runtime-breadcrumb-wrap");
    wrap.id = "sparc-driver-runtime-breadcrumb-wrap";
    var crumb = el("nav", "sparc-driver-runtime-breadcrumb");
    crumb.id = "sparc-driver-runtime-breadcrumb", crumb.setAttribute("aria-label", "Breadcrumb");
    function addLink(source, fallbackText, fallbackHref){
      var href = source && source.getAttribute("href")?source.getAttribute("href"): fallbackHref;
      if(href){
        var a = document.createElement("a");
        a.href = href, a.textContent = source && clean(source.textContent)?clean(source.textContent): fallbackText, crumb.appendChild(a)
      }
      else crumb.appendChild(el("span", "", fallbackText))
    }
    function sep(){
      crumb.appendChild(el("span", "sparc-driver-runtime-breadcrumb__sep", "\u203A"))
    }
    if(addLink(homeLink, "Home", "/"), sep(), addLink(seriesLink, "Driver Series", "/collections/driver-series"), productTitle){
      sep();
      var current2 = el("span", "sparc-driver-runtime-breadcrumb__current", productTitle);
      current2.setAttribute("aria-current", "page"), crumb.appendChild(current2)
    }
    wrap.appendChild(crumb), insertionTarget.parentNode.insertBefore(wrap, insertionTarget), originalBreadcrumb && !originalBreadcrumb.contains(wrap) && originalBreadcrumb.style.setProperty("display", "none", "important");
    function cleanupLegacyFragments(){
      var titleNorm = clean(productTitle).toLowerCase();
      qa("*", document).forEach(function(node){
        if(!(node === wrap || node === crumb || wrap.contains(node) || node.contains(wrap))){
          var rect = node.getBoundingClientRect();
          if(!(rect.top < 40 || rect.top > 260 || rect.left < 20 || rect.left > 700 || rect.width <= 0 || rect.width > 800 || rect.height <= 0 || rect.height > 90)){
            var text = clean(node.textContent).toLowerCase(), hasHome = text.indexOf("home") !== - 1, hasSeries = text.indexOf("driver series") !== - 1, hasTitle = titleNorm && text.indexOf(titleNorm) !== - 1;
            if(hasHome && hasSeries || hasSeries && hasTitle){
              if(qa("img", node).length || qa("#ProductSection", node).length)return;
              node.style.setProperty("display", "none", "important")
            }
          }
        }
      })
    }
    cleanupLegacyFragments(), hideRenderedLegacyBreadcrumb(wrap, productTitle), hideLegacyBreadcrumbByLinks(wrap, productTitle), cleanupDriverBreadcrumbDuplicates(wrap, productTitle), [80, 220, 500, 1e3].forEach(function(delay){
      setTimeout(function(){
        cleanupLegacyFragments(), hideRenderedLegacyBreadcrumb(wrap, productTitle), hideLegacyBreadcrumbByLinks(wrap, productTitle), cleanupDriverBreadcrumbDuplicates(wrap, productTitle)
      }, delay)
    })
  }
  function isDirectProductPath(){
    return String(window.location.pathname || "").toLowerCase().indexOf("/products/") !== - 1
  }
  function isDriverProductPage(){
    var path = String(window.location.pathname || "").toLowerCase();
    return path.indexOf("/collections/driver-series/") !== - 1?!0: !!document.getElementById("sparc-driver-finish") && !!document.getElementById("sparc-driver-grip")
  }
  function start(){
    if(!isDriverProductPage()){
      isDirectProductPath() && (start._directUrlRetries || 0) < 20 && (start._directUrlRetries = (start._directUrlRetries || 0) + 1, setTimeout(start, 500));
      return
    }
    if(start._directUrlRetries = 0, !document.getElementById("sparc-driver-configurator")){
      var missing = allRefsPresent();
      if(missing.length){
        (!start._lastMissingLog || Date.now() - start._lastMissingLog > 3e3) && (console.info("[SPARC DRIVER V1.14] Waiting for Driver Hulk core selectors:", missing), start._lastMissingLog = Date.now()), setTimeout(start, 500);
        return
      }
      if(prepareDriverProductLayout(), !buildPanel()){
        (!start._lastBuildLog || Date.now() - start._lastBuildLog > 3e3) && (console.info("[SPARC DRIVER V1.14] Core selectors found; waiting for Driver product-options mount."), start._lastBuildLog = Date.now()), setTimeout(start, 500);
        return
      }
      refreshRefs(), ensureAccessoryUI(), setTimeout(delayedSync, 120), applyV11Polish(), replaceDriverBreadcrumb(), setTimeout(replaceDriverBreadcrumb, 120), installRequiredValidation();
      var observer = new MutationObserver(function(){
        refreshRefs(), delayedSync(), setTimeout(applyV11Polish, 80)
      });
      observer.observe(sourceHost, {
        subtree: !0, childList: !0
      }), sourceHost.addEventListener("change", delayedSync, !0), sourceHost.addEventListener("input", delayedSync, !0), window.addEventListener("resize", function(event){
        event && event.__sparcDriverLayoutRefresh || scheduleResize(120)
      }), panel.addEventListener("transitionend", function(event){
        var target = event.target;
        target && (target.classList.contains("sparc-accordion__body") || target.classList.contains("sparc-conditional")) && scheduleResize(24)
      }, !0);
      var detailData = optionDetailData();
      detailData && Array.isArray(detailData.entries) && console.info("[SPARC DRIVER V1.14] Shopify option-detail entries loaded:", detailData.entries);
      var leadData = leadTimeData();
      if(leadData && Array.isArray(leadData.rules)){
        console.info("[SPARC DRIVER V1.14] Lead-time bridge loaded:", {
          bridgeVersion: leadData.bridgeVersion, ruleCount: leadData.ruleCount, productHandle: leadData.productHandle, seriesScope: leadData.seriesScope, rules: leadData.rules
        });
        var baseRule = baseLeadRule();
        baseRule || console.warn("[SPARC DRIVER V1.14] No valid Driver Series Base lead-time rule was found.")
      }
      delayedSync(), scheduleResize(), setTimeout(applyV11Polish, 150), setTimeout(applyV11Polish, 600), console.info("[SPARC DRIVER] Hulk image-swatch + condition source-of-truth revision active.")
    }
  }
  document.readyState === "loading"?document.addEventListener("DOMContentLoaded", start, {
    once: !0
  }): start()
})();
